import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect';
import PHE from 'print-html-element';
import moment from "moment";
import tinycolor from "tinycolor2";

Vue.use(Vuex)

const localPrefix = location.host.indexOf("localhost") != -1 ? "http://localhost:53911" : "";

const AxiosCancelRequest = axios.CancelToken;

const getCookie = function (name) {
	var b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
	return b ? b.pop() : null;
}

function getTenantInfoForRequest(overrideObject) {

    var info = {
        url: encodeURIComponent(window.location.hostname.replace(/^(https?:\/\/)?(www\.)?/, '')),
        origin: encodeURIComponent(window.location.origin),
        page: encodeURIComponent(window.location.href),
        //tenantid: window.tenantURL.Parameters.id,
        Fid: "",
        salonid: state.selectedSalonID,
        userid: state.user.id
    }

    Object.assign(info,overrideObject);

    return info;
}

const state = {
	VERSION_BASKET: "1.2",
	PHE: PHE,
	trackingParamsString: "",
	loading: false,
	EventBus: new Vue(),
    stripeInstance: null,
	stripeClientSecret: "pi_1DsTVZ2eZvKYlo2C8Hhr3cC3_secret_9rXRkcKUPf9Tg6tNsxd9XHCBB",
    paymentsLoading: false,
	makeBookingLoading: false,
    existingCardsLoading: false,
    existingcards: [],
	klarnaCallbackFlow: false,
	klarnaButtonText: "Pay full with",
	isKlarnaEnabled: false,
    settings: {
        bgImage: "/img/bg-generic.png",
        logoImage: "https://www.greathairdressing.com/files/2019/01/logo-2019-e1548084901241.png"
    },
    parameters: {
        AutoOpenDropDowns: true,
        BA_AndroidAPPLink: "",
        BA_AppName: "",
        BA_IOSAPPLink: "",
        BA_ShowChoiceBackgroundImages: true,
        BackgroundImageLink: "https://saloniqimages.blob.core.windows.net/useruploads/BackgroundImages/CUC001.jpg",
        CDIndex_Purchase: 2,
        CDIndex_Salon: 1,
        CDIndex_Teammember: 3,
        CDIndex_Widget: 5,
        ClickMeIndicatorText: "Click Here for online Bookings",
        ClickmeIndicator: "1",
        CloseText: "Close",
        CssLink: "https://saloniqimages.blob.core.windows.net/useruploads/styles/CUC001_BookingWidget.min.CSS",
        Currency: "£",
        CurrencyABB: "GBP",
        DenominationID: "",
        EnableCustomIndices: false,
        FBPixelID: "",
        GACrossTrackingDomains: "",
        GATrackingID: "",
        GATrackingIDSalonIQ: "UA-159631881-1",
        GCDefaultSalon: "0f3bc7d0-38d4-10be-2960-1c6d71b3dc8a",
        GCID: "",
        HideMemo: false,
        HidePromo: false,
        HostName: "http://localhost:55576/",
        ImagePath: "https://saloniqimages.blob.core.windows.net/useruploads/../",
        LoggedIn: true,
        LoginRequired: "0",
        LogoLink: "https://saloniqimages.blob.core.windows.net/useruploads/Logo/CUC001.jpg",
        Onesalon: "",
        OnlineBookingsEnabled: true,
        OnlineGCSaleType: 0,
        OpenText: "Book Online Now",
        PreLoadResources: 1,
        Prepopulate: 0,
        //PrepopulateData: {},
        RecaptchaEnabled: false,
        ShowPoints: true,
        ShowServiceSubCategories: false,
        ThankYouPage: "",
        closeLabelTextColor: "rgba(0,0,0,1)",
        er: ".a1.11-.13 .3 .3a .7 .10 1 1.2s: 1e7d7624-feb7-4950-a6be-5fbb1498ee394 localhost 4.4a 4.4e 4.4f5 5.5 CUC001 5.6 5.7 5.8 6  ap1 8 9 10 11 11.5 13 14 15 16 ",
        fp: "1124070711000179",
        gcspid: "",
        listGroupHeaderColor: "rgba(182,182,182,1)",
        listGroupHeaderTextColor: "rgba(255,255,255,1)",
        openLabelTextColor: "rgba(0,0,0,1)",
        path: ".a1.11-.13 .3 .3a .7 .10 1 1.2s: 1e7d7624-feb7-4950-a6be-5fbb1498ee394 localhost 4.4a 4.4e 4.4f5 5.5 CUC001 5.6 5.7 5.8 6  ap1 8 9 10 11 11.5 13 14 15 16 ",
        refreshedon: "20200720221355",
        sp: "pk_test_24XUueypg1qQIFFlFkmnfxkP",
        wrapperBackgroundColorLeft: "#e8d4ff",
        wrapperBackgroundColorRight: "#e8d4ff"
    },
    salons: [],
    loadingSalons: false,
    salonTeam: [],
    loadingSalonTeam: false,
    denominations: null,
	giftcardbalance: null,
	courses: null,
	subscriptions: null,
	loadingQuestions: false,
	loadingUpgrades: false,
	questionsdata: null,
	loadingWrongQuestions: false,
    products: [],
	categories:[],
	brands:[],
	subbrands: [],
	originalSalonID: "", // the salonid in the URL
    selectedSalonID: "",
	selectedSalon: {
		ID: "",
		ImageLink: "",
		Name: "Please select salon..."
	},
    windowWidth: 0,
    urlParams: null,
    basketOn: false,
	basket: [],
    initialising: true,
    loadingProducts: true,
    systemError: "",
    filters: [
		{
            id: "recommendedproducts",
            property: "ProductId",
            type: 4, // product id
            title: "Recommended products",
            selected: false,
			public: false,
			options: [] // array of produc ids
		},
		{
            id: "favourite",
            property: "Favourite",
            type: 5, //
            title: "Favourite products",
            selected: false,
			public: true,
			options: []
		},
		{
            id: "price",
            property: "RRP",
            type: 3, // min max user-defined
            title: "Price",
            selected: false,
			public: true,
			options: [{
	            id: 0,
	            name: "",
	            min: 0,
	            max: 1000,
	            selected: false
	    	}]
		},
        {
            id: "producttype",
            property: "ProductTypeId",
            type: 2, // string
            title: "Type",
            selected: false,
			public: true,
            selectedOptionName: "",
            selectedOptionID: "",
            options: [
            ]
        },
        {
            id: "category",
            property: "ProductCategoryId",
            type: 2, // string
            title: "Brand",
            selected: false,
			public: true,
            selectedOptionName: "",
            selectedOptionID: "",
            options: [
            ]
        },
        {
            id: "subcategory",
            property: "ProductSubCategoryId",
            type: 2, // string
            title: "Subcategory",
            selected: false,
			public: true,
            selectedOptionName: "",
            selectedOptionID: "",
            options: [
            ]
        }
    ],
    priceRanges: [
        {
            id: 0,
            name: "",
            min: 0,
            max: 9.99,
            selected: false
        },
        {
            id: 1,
            name: "",
            min: 10,
            max: 19.99,
            selected: false
        },
        {
            id: 2,
            name: "",
            min: 20,
            max: 49.99,
            selected: false
        },
        {
            id: 3,
            name: "",
            min: 50,
            max: 99.99,
            selected: false
        },
        {
            id: 4,
            name: "",
            min: 100,
            max: 0,
            selected: false
        }
    ],
    isMobile: isMobile,
    platformDetails: {},
    user: {
        id: "",
        authorised: false,
        authenticating: false,
        missingdetails: false,
        missingdetailserror: "",
        loading: false,
        details: null,
        addresses: {
            billing: null,
            delivery: []
        }
    },
    postcodelookupresults: {
		type:1,
	    response: {
			AddressInfoList: []
		}
	},
    cookieconsent: null,
    notification: null,
    team: [],
    desiredPage: "",
	desiredParams: [],
	loadingdeliveryaddress: false,
	loadingpostcodes: false,
	loadingdenominations: false,
	loadingcourses: false,
	loadingsubscriptions: false,
	checkingGiftcardBalance: false,
	giftcardBalance: null,
	mygiftcards: [],
	mycourses: [],
	lastSalonTeamSalonID: "", //last salon ID that loaded salon team
	loadingbookingavailability: false,
	checkingAvalability: false,
	recommendations: [],
	bounceBasket: false,
	bounceBasketTimer: null,
	pastproducts: [],
	loadingsalonreviews: false,
	salonreviews: null,
	priceRangeLimits: { min:0, max: 1000 },
	services: [],
	loadingservices: false,
	servicecategories: [],
	coursescategories: [],
	teammembers: [],
	loadingteammembers: false,
	loadingdatestatus: false,
	loadingDateStatusRequestCancel: null,
	temporaryData: [],
	loadingcharge: false,
	upgrades: [],
	bookings: {
		future: [],
		past: []
	},
	forcedTeammember: "",
	loadingBookings: false,
	loadingPromocode: false,
	tags: [],
	bookingrequiredfields: false,
	headerConfig: "",
	chosenCourse: null,
	chosenSubscription: null,
	tmrecommendation: null,
	checkingProductAvailability: false,
	switchCategory: "",
	GATrackingID: "", // defined by the customer
    GATrackingIDSalonIQ: "", // hardcoded, SalonIQ property
	gaConfigCustomDimensionsObject: {
    	'custom_map': {
        	// 'dimension1': 'salon',
        	// 'dimension2': 'purchase',
        	// 'dimension3': 'teammember',
			// 'dimension4': 'tenant',
			// 'dimension5': 'widget'
		},
		'linker': {
			'domains': [],
			'accept_incoming': true
		}
    },
    gaConfigCustomDimensionsObjectSalonIQ: {
    	'custom_map': {
        	'dimension1': 'salon',
        	'dimension2': 'purchase',
        	'dimension3': 'teammember',
			'dimension4': 'tenant',
			'dimension5': 'widget'
		}
    },
	// queue mode start
	queuemodestatus: null,
	queuemodestatusloading: false,
	queuemodepromocodeloading: false,
	loadingqueuemodestuff: false,
	// queue mode end
	mysubscriptions: null,
	loadingmysubscriptions: false,
	addingToWaitingList: false,
	validGiftcards: [],
	validatingNewGiftcard: false
}

const mutations = {

	set_queuemodestatusloading (state, params) {
		state.queuemodestatusloading = params;
	},
	set_queuemodestatus (state, params) {
		state.queuemodestatus = params;
	},
	set_queuemodepromocodeloading (state, params) {
		state.queuemodepromocodeloading = params;
	},
	set_loadingqueuemodestuff (state,params) {
		state.loadingqueuemodestuff = params;
	},

	set_addingtowaitinglist (state, params) {
		state.addingToWaitingList = params;
	},
	set_switchcategory (state, params) {
		state.switchCategory = params;
	},
	set_checkingproductavailability (state, params) {
		state.checkingProductAvailability = params;
	},
	set_tmrecommendation (state, params) {
		state.tmrecommendation = params;
	},
    set_platformdetails (state, params) {
	    state.platformDetails = params;
	},
    set_setting (state,params) {
        state.settings[params.section][params.switch] = params.value;
    },
    set_settings (state,params) {
        state.settings = params;
    },
	set_forcedteammember (state,params) {
		state.forcedTeammember = params;
	},
    set_resizeparams (state,params) {
        state.windowWidth = params;
    },
    set_urlparams(state, params) {
        state.urlParams = params;
        if( (typeof state.urlParams.salonid == "undefined" || state.urlParams.salonid == "") && (typeof state.urlParams.tokenid == "undefined" || state.urlParams.tokenid == "") ) {
            state.systemError = "Error. Missing token.";
        }
	},
    set_parameters(state, params) {
		params["GA4IDSalonIQ"] = "G-VYY3B6KGFJ";
        state.parameters = params;
	},
    set_basketon(state,params) {
        state.basketOn = params;
    },
    set_denominations(state,params) {
		params.Denomination.sort( (a,b) => {
			return a.Sequence - b.Sequence;
		});
        state.denominations = params;
    },
	set_giftcardbalance(state,params) {
        state.giftcardbalance = params;
    },
	set_courses(state,params) {
		for (var i = 0; i < params.Courses.length; i++) {
			params.Courses[i]["showDetailedDescription"] = false;
		}
		params.Courses.sort( (a,b) => {
			if(a.Description < b.Description) return -1;
			else return 1;
		});
		
		params.Categories.forEach((item, i) => {
			item["selected"] = false;
			item["DetailedCategoryDescription"] = typeof item.DetailedCategoryDescription == "undefined" ? "" : item.DetailedCategoryDescription;
		});
		params.Categories.sort( (a,b) => {
			return a.Sequence - b.Sequence;
		})
		
		state.courses = params;
    },
	set_subscriptions(state,params) {
		for (var i = 0; i < params.Subscriptions.length; i++) {
			params.Subscriptions[i]["showDetailedDescription"] = false;
		}
		params.Subscriptions.sort( (a,b) => {
			if(a.Sequence < b.Sequence) return -1;
			if(a.Sequence > b.Sequence) return 1;
			if(a.Description < b.Description) return -1;
			if(a.Description > b.Description) return 1;
			else return 0;
		});
        state.subscriptions = params.Subscriptions;
    },
    set_products (state, params) {

		params.Products.forEach( (item, i) => {
			item["checkingProductAvailability"] = false;
		});

		state.tags = params.Tags;
		state.products = params.Products;

		var maxPrice = 0;
		for(var i=0; i<state.products.length; i++) {
			if(state.products[i].RRP > maxPrice) maxPrice = state.products[i].RRP;
		}
		var len = maxPrice.toString().length;
		maxPrice = Math.ceil( maxPrice / Math.pow(10,len-1) ) * Math.pow(10,len-1);
		state.priceRangeLimits.max = maxPrice;

		var producttypes = state.filters.find( function(a) {return a.id=="producttype"} ).options;
        for(var i=0; i<params.ProductType.length; i++) {
            var isInArray2 = typeof producttypes.find(function(a){ return a.id == params.ProductType[i].ProductTypeId }) != "undefined";
            if(!isInArray2) {
                producttypes.push({
                    id: params.ProductType[i].ProductTypeId,
                    name: params.ProductType[i].Description,
					selected: false,
					children: []
                });
            }
        }
		producttypes.sort(function(a,b){
			if(a.name > b.name) return 1;
			if(a.name < b.name) return -1;
			return 0;
		});
		state.categories = producttypes;

        var categories = state.filters.find( function(a) {return a.id=="category"} ).options;
        for(var i=0; i<params.Categories.length; i++) {
            var isInArray1 = typeof categories.find(function(a){ return a.id == params.Categories[i].ProductCategoryId }) != "undefined";
            if(!isInArray1) {
                categories.push({
                    id: params.Categories[i].ProductCategoryId,
                    name: params.Categories[i].Description,
					detaileddescription: params.Categories[i].DetailedDescription,
					image: params.Categories[i].ProductCategoryImage,
					Website: params.Categories[i].Website,
					selected: false,
					children: []
                });
            }
        }
		categories.sort(function(a,b){
			if(a.name > b.name) return 1;
			if(a.name < b.name) return -1;
			return 0;
		});
		state.brands = categories;

        var subcategories = state.filters.find( function(a) {return a.id=="subcategory"} ).options;
        for(var i=0; i<params.SubCategories.length; i++) {
            var isInArray1 = typeof subcategories.find(function(a){ return a.id == params.SubCategories[i].ProductSubCategoryId }) != "undefined";
            if(!isInArray1) {
                subcategories.push({
                    id: params.SubCategories[i].ProductSubCategoryId,
                    name: params.SubCategories[i].Description,
					image: params.SubCategories[i].ProductSubCategoryImage,
					selected: false,
					children: []
                });
            }
        }
		subcategories.sort(function(a,b){
			if(a.name > b.name) return 1;
			if(a.name < b.name) return -1;
			return 0;
		});
		state.subbrands = subcategories;

		var category,brand,subbrand,product;
		// for(var i=0; i<state.categories.length; i++) {
		// 	category = state.categories[i];
		// 	var foundBrand = false;

			for(var j=0; j<state.brands.length; j++) {
				brand = state.brands[j];
				var foundSubBrand = false;

				for(var k=0; k<state.subbrands.length; k++) {
					subbrand = state.subbrands[k];
					// for(var l=0; l<state.products.length; l++) {
					// 	product = state.products[l];
					// 	if( product.ProductTypeId == category.id && )
					// }
					product = state.products.find( (a) => {
						return /*(a.ProductTypeId === category.id) &&*/ (a.ProductCategoryId === state.brands[j].id) && (a.ProductSubCategoryId === state.subbrands[k].id);
					})

					if(typeof product != "undefined") {
						//foundSubBrand = true;
						var fbrand = brand;//category.children.find( (b) => {return b.id == brand.id});
						if(typeof fbrand != "undefined") {
							if( typeof fbrand.children.find( (b) => {return b.id == subbrand.id}) == "undefined" ) fbrand.children.push(JSON.parse(JSON.stringify(subbrand)));
						} else {
							fbrand = JSON.parse(JSON.stringify(brand));
							fbrand.children.push(JSON.parse(JSON.stringify(subbrand)));
							category.children.push(fbrand);
						}

						//break;
					}
				}

				if(foundSubBrand == true) {
					foundBrand = true;
					//if( typeof category.children.find( (b) => {return b.id == brand.id}) == "undefined" ) category.children.push(brand);
					//if( typeof brand.children.find( (b) => {return b.id == subbrand.id}) == "undefined" ) brand.children.push(subbrand);
					//break;
				}
			}

		// 	if(foundBrand == true) {
		// 		//if( typeof category.children.find( (b) => {return b.id == brand.id}) == "undefined" ) category.children.push(brand);
		// 	}
		// }

        // prices
        // var prices = state.filters.find( function(a) {return a.id=="price"} ).options;
        // for(var i=0; i<prices.length; i++) {
        //     var pricerange = prices[i];
        //     var str = '';
        //     if(pricerange.min == 0) {
        //         str += '<span class="currency">'+state.parameters.Currency+'</span>'+pricerange.max.toFixed(2) + " or less";
        //     } else if(pricerange.max == 0) {
        //         str += '<span class="currency">'+state.parameters.Currency+'</span>'+pricerange.min.toFixed(2) + " or more";
        //     } else {
        //         str += '<span class="currency">'+state.parameters.Currency+'</span>'+pricerange.min.toFixed(2)+" to " + '<span class="currency">'+state.parameters.Currency+'</span>'+pricerange.max.toFixed(2);
        //     }
        //     pricerange.name = str;
        // }
        // change state

    },
    set_paymentsloading(state,params) {
        state.paymentsLoading = params;
    },
	set_makebookingloading(state,params) {
        state.makeBookingLoading = params;
    },
    set_existingcards (state,params) {
        for (var i = 0; i < params.length; i++) {
			params[i]["open"] = false;
		}
        state.existingcards = params;
    },
    set_initialising (state, params) {
        state.initialising = params;
    },
    set_loadingproducts (state, params) {
        state.loadingProducts = params;
    },
    set_systemerror (state, params) {
        state.systemError = params;
    },
    set_authenticated (state, payload) {
      state.user.authorised = payload
    },
	set_userid (state, payload) {
      state.user.id = payload;
	},
	set_authenticating (state, params) {
	    state.user.loading = params;
	},
	set_isforcedlogin (state, params) {
	    state.isForcedLogin = params;
	},
    set_userdetails (state, params) {

		if(params.Clientimage == "") params.Clientimage = "/img/woman-placeholder.png";

        state.user.details = params;

        state.existingcards = params.Cards.Cards;

        state.user.addresses.billing = {
            Address1: params.Address1,
            Address2: params.Address2,
            Address3: params.Address3,
            Address4: params.Address4,
			County:	  params.County,
            Town:     params.Town,
            Postcode: params.Postcode,
        }
    },
    set_loadinguserdetails (state, params) {
        state.user.loading = params;
    },
    set_showmissingdetails (state, params) {
        state.user.missingdetails = params;
    },
    set_missingdetailserror (state, params) {
        state.user.missingdetailserror = params;
    },
    set_postcodelookupresults (state, params) {
	    state.postcodelookupresults = params;
	},
    set_cookieconsent(state, params) {
		state.cookieconsent = params;
	},
    set_notification (state, params) {
		if(params != null && params.style['background-color'] == "red") {
			params.style['background-color'] = state.parameters.WarningColour;
		}
        state.notification = params;
    },
    set_salons (state, params) {
        state.salons = params.Salons;
    },
    set_loadingsalons (state, params) {
        state.loadingSalons = params;
    },
    set_salonteam(state, params) {
		params.sort( (a,b) => {
			return a.SequenceNumber - b.SequenceNumber;
		});
		state.salonTeam = params;
	},
    set_loadingsalonteam (state, params) {
        state.loadingSalonTeam = params;
    },
    set_selectedSalonID (state, params) {
		if(params == null || params == "") return;
        state.selectedSalonID = params;
        //state.selectedSalon = state.salons.find(p => p === state.selectedSalonID);
		this.commit("set_selectedSalon",state.salons.find(p => p.ID == state.selectedSalonID));
    },
    set_selectedSalon (state, params) {
        if(params != null) {
            state.selectedSalon = params;
            state.selectedSalonID = state.selectedSalon.ID;
			state.parameters.GA4ID = state.selectedSalon.GA4ID;
			if(state.selectedSalon.GA4ID != "") {
				var gaTrackingDomains = state.parameters.GACrossTrackingDomains.split(",");
				gtag('config', state.parameters.GA4ID, {linker:{domains:gaTrackingDomains}} );
			}
        } else {
            state.selectedSalon = null;
        }
    },
    set_salonsLoading (state, params) {
        state.loading = params;
    },
	set_specialdays (state, params) {
		state.specialDays = params;
	},
	set_specialdaymessage (state, params) {
		state.specialDayMessage = params;
	},
	set_closeddays (state, params) {
		state.closedDays = params;
	},
    set_desiredpage (state, params) {
        state.desiredPage = params;
    },
	set_desireddata (state,params) {
		state.desiredPage = params.page;
		state.desiredParams = typeof params.params == "undefined" ? {} : params.params;
	},
	set_deliveryaddresses (state, params) {
		if(typeof params == "undefined") return;
		params.sort( (a,b) => { return b.CreatedDate - a.CreatedDate } );
		state.user.addresses.delivery = params;
	},
	set_recommendations (state, data) {
		state.recommendations = data;
	},
	set_pastproducts (state, data) {
		state.pastproducts = data;
	},
	add_item (state, params) {
        if(params.type === 3) {
			clearTimeout(state.bounceBasketTimer);
			state.bounceBasket = true;
			state.bounceBasketTimer = setTimeout( ()=> {
				state.bounceBasket = false;
			},1000);
            var index = state.basket.findIndex(function(a){
                return a.type === 3 && a.data.product.ProductId === params.data.product.ProductId;
            });
            if(index>-1) {
                state.basket[index].data.quantity += params.data.quantity;
                return;
            }
        }
        state.basket.push(params);
    },
    remove_item (state, params) {
        var index = state.basket.findIndex(function(a){
            // service
            if(params.type === 1) {
                return a.type === 1 && a.data.service.id === params.data.service.id && a.data.teammember.id === params.data.teammember.id;
            }
            // giftcard
            if(params.type === 2) {
                return a.type === 2 && a.data.denomination.GCDenominationId === params.data.denomination.GCDenominationId;
            }
            // product
            if(params.type === 3) {
                return a.type === 3 && a.data.product.ProductId === params.data.product.ProductId;
            }
        });
        state.basket.splice(index,1);
    },
	set_loadingdeliveryaddress (state,params) {
		state.loadingdeliveryaddress = params;
	},
	set_loadingpostcodes (state, params) {
		state.loadingpostcodes = params;
	},
	set_loadingdenominations (state,params) {
		state.loadingdenominations = params;
	},
	set_loadingcourses (state,params) {
		state.loadingcourses = params;
	},
	set_loadingsubscriptions (state,params) {
		state.loadingsubscriptions = params;
	},
	set_checkinggiftcardbalance (state,params) {
		state.checkingGiftcardBalance = params;
	},
	set_giftcardbalance (state,params) {
		state.giftcardBalance = params;
	},
	set_mygiftcards (state,params) {
		state.mygiftcards = params;
	},
	set_validgiftcards (state,params) {
		params.forEach(function(g){
			g["selected"] = false;
		})
		state.validGiftcards = params;
	},
	set_mycourses (state,params) {
		state.mycourses = params;
	},
	set_loadingbookingavailability (state,params) {
		state.loadingbookingavailability = params;
	},
	set_checkingavailability (state,params) {
		state.checkingAvalability = params;
	},
	set_loadingsalonreviews (state,params) {
		state.loadingsalonreviews = params;
	},
	set_salonreviews (state,params) {
		state.salonreviews = params;
	},
	set_services (state, params) {
		// var foundIndex = params.findIndex(function(a){ return a.ServiceId == "d9fccf32-092c-44e5-a174-57fba2e00ab8"});
		// params.splice(foundIndex,1);
		params.forEach((item, i) => {
			item["selected"] = false;
			item["ServiceLC"] = item.Service.toLowerCase();
		});		
		state.services = params;
	},
	set_loadingservices (state,params) {
		state.loadingservices = params;
	},
	set_servicecategories (state, params) {
		params.forEach((item, i) => {
			item["selected"] = false;
		});
		params.sort( (a,b) => {
			return a.Sequence - b.Sequence;
		})
		state.servicecategories = params;
	},	
	set_loadingteammembers (state,params) {
		state.loadingteammembers = params;
	},
	set_teammembers (state,params) {
		params.TeamMembers.sort(function(a,b){
			return a.Order - b.Order;
		})
		state.switchCategory = params.CategoryId;		
		params.TeamMembers.forEach((item, i) => {
			if(item.TeamMemberId != "00000000-0000-0000-0000-000000000000") item["selected"] = false;
		});
		state.teammembers = params.TeamMembers;
	},
	set_loadingdatestatus (state,params) {
		state.loadingdatestatus = params;
	},
	set_loadingcharge (state,params) {
		state.loadingcharge = params;
	},
	set_shopmessage (state,params) {
		state.parameters.BannerMessageShop = params;
	},	
	set_subscriptionsmessage (state,params) {
		state.parameters.BannerMessageSubscriptions = params;
	},
	set_coursesmessage (state,params) {
		state.parameters.BannerMessageCourse = params;
	},
	set_giftcardsmessage (state,params) {
		state.parameters.BannerMessageGiftCard = params;
	},
	set_bookmessage (state,params) {
		state.parameters.BannerMessageBook = params;
	},
	set_loading (state, params) {
		state.loading = params;
	},
	set_questionsloading (state, params) {
		state.loadingQuestions = params;
	},
	set_loadingupgrades (state, params) {
		state.loadingUpgrades = params;
	},
	set_questionsdata (state, params) {
		for(var i=0; i<params.Questions.length; i++) {
			params.Questions[i]["on"] = !params.Questions[i].Answer;
		}
		state.questionsdata = params;
	},
	set_upgrades (state, params) {
		state.upgrades = params;
	},
	set_loadingwrongquestions (state, params) {
		state.loadingWrongQuestions = params;
	},
	set_bookings (state, params) {
		var futureBookings = [];
		var pastBookings = [];
		for(var i=0; i<params.length; i++) {
			//var timestamp = params[i].BookingDateTimeStamp;
			//var today = ((new Date()).setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000) / 1000;
			//params[i].Status = 2;
			if(params[i].Status<2) {
				params[i]["future"] = true;
				futureBookings.push(params[i]);
			} else {
				params[i]["future"] = false;
				pastBookings.push(params[i]);
			}
			futureBookings.sort(function (a, b) {
				var time1 = a.BookingDateTimeStamp;
				var time2 = b.BookingDateTimeStamp;
				if (time1 < time2) { return -1; }
				if (time1 > time2) { return 1; }
				if (time1 == time2) { return 0; }
			});
		}
		state.bookings = {
			future: futureBookings,
			past: pastBookings
		}
	},
	set_loadingbookings (state, params) {
		state.loadingBookings = params;
	},
	set_loadingpromocode (state, params) {
		state.loadingPromocode = params;
	},
	set_validatingnewgiftcard (state, params) {
		state.validatingNewGiftcard = params;
	},
	set_bookingrequiredfields (state, params) {
		state.bookingrequiredfields = params;
	},
	set_klarnacallbackflow (state, params) {
		state.klarnaCallbackFlow = params;
	},
	set_chosencourse (state, course) {
		state.chosenCourse = course;
	},
	set_chosensubscription (state, course) {
		state.chosenSubscription = course;
	},
	set_stripeclientsecret (state,params) {
		state.stripeClientSecret = params;
	},
	set_mysubscriptions (state,params) {
		state.mysubscriptions = params;
	},
	set_loadingmysubscriptions (state,params) {
		state.loadingmysubscriptions = params;
	}
}

const getters = {
	get_addingtowaitinglist (state) {
		return state.addingToWaitingList;
	},
	get_queuemode (state, getters) {
        return false;//getters.get_selectedsalon != null ? getters.get_selectedsalon.QueueMode : false;
    },
	get_queuemodestatus (state) {
        return state.queuemodestatus;
    },
	get_queuemodepromocodeloading (state) {
		return state.queuemodepromocodeloading;
	},
    get_queuemodestatusloading (state) {
        return state.queuemodestatusloading;
    },
	get_loadingqueuemodestuff (state) {
        return state.loadingqueuemodestuff;
    },

	get_trackingparamsstring () {
		return state.trackingParamsString;
	},
	get_switchcategory () {
		return state.switchCategory;
	},
	get_checkingproductavailability (state) {
		return state.checkingProductAvailability;
	},
	get_eventbus (state) {
		return state.EventBus;
	},
	get_userid (state) {
		return state.user.id;
	},
    get_settings (state) {
        return state.settings;
    },
    get_initialising (state) {
        return state.initialising;
    },
	get_loading (state) {
		return state.loading;
	},
    get_loadingproducts (state) {
        return state.loadingProducts;
    },
    get_bgimage (state) {
        return state.settings.bgImage;
    },
    get_logoimage (state) {
        //return 'url(' + state.parameters.LogoLink + ')';
		return state.parameters.LogoLink;
    },
    get_windowwidth (state) {
        return state.windowWidth;
    },
    get_urlparams (state) {
        return state.urlParams;
    },
    get_parameters (state) {
        return state.parameters;
	},
    get_salons (state) {
        return state.salons;
    },
    get_selectedsalon (state) {
        var salon = state.salons.find(function(a){return a.ID === state.selectedSalonID});
        return typeof salon != "undefined" ? salon : null;
    },
    getSelectedSalonID() {
	    return state.selectedSalonID;
    },
    getFirstSalonID() {
        if (state.salons.length > 0) {
            return state.salons[0].ID;
        } else {
            return "";
        }
    },
	getSalonsLoading () {
	    return state.loading;
    },
	get_deliveryaddresses () {
		return state.user.addresses.delivery;
	},
    get_specialdays() {
        return state.specialDays;
    },
    get_specialdaymessage(state, params) {
        return state.specialDayMessage;
    },
    get_closeddays(state, params) {
        return state.closedDays;
	},
	get_closeddaysFORMATTED(state, params) {
		var cd = [];
		for (var i = 0; i < state.closedDays.length; i++) {
			var arr = state.closedDays[i].split("/");
			cd.push(new Date(arr[2], parseInt(arr[0])-1, arr[1]));
		}
		return { dates: cd, to: moment().add(-1,"days").toDate() };
	},
    get_tclink() {
        return state.selectedSalon ? state.selectedSalon.TCLink : "";
	},
    get_salonteam (state) {
        return state.salonTeam;
    },
    get_loadingsalonteam (state) {
        return state.loadingSalonTeam;
    },
    get_ismobile (state) {
        return state.windowWidth <= 768;
    },
    get_basketon (state) {
        return state.basketOn;
    },
    get_denominations(state) {
        return state.denominations;
    },
	get_giftcardbalance(state) {
        return state.giftcardbalance;
    },
	get_courses(state) {
        return state.courses;
    },
	get_subscriptions(state) {
		return state.subscriptions;
	},
    get_products(state) {
        return state.products;
    },
    get_stripeinstance (state) {
        return state.stripeInstance;
    },
    get_stripeapikey (state) {
        return state.parameters.MyStripePublishableKey;
    },
    get_spid (state) {
        return state.parameters.spid;
    },
    get_paymentsloading (state) {
        return state.paymentsLoading;
    },
	get_makebookingloading (state) {
		return state.makeBookingLoading;
	},
    get_existingcardsloading (state) {
        return state.existingCardsLoading;
    },
    get_existingcards (state) {
        return state.existingcards;
    },
    get_currency (state) {
        return state.parameters.Currency;
    },
    get_systemerror (state) {
        return state.systemError;
    },
    get_filter_priceranges (state) {
        return state.priceRanges;
    },
    get_filters (state) {
        return state.filters;
    },
    get_ismobile (state) {
        return state.isMobile;
    },
    get_isauthorised (state) {
        return state.user.authorised;
    },
    get_authenticating (state) {
        return state.user.loading;
    },
    get_recaptchaenabled (state) {
        return state.parameters.RecaptchaEnabled;
    },
    get_userdetails (state) {
        return state.user.details;
    },
    get_loadinguserdetails (state) {
        return state.user.loading;
    },
    get_showmissingdetails (state) {
        return state.user.missingdetails;
    },
    get_missingdetailserror (state) {
        return state.user.missingdetailserror;
    },
    get_postcodelookupresults (state) {
        return state.postcodelookupresults;
	},
    get_cookieconsent(state) {
		return state.cookieconsent;
	},
    get_notification (state) {
        return state.notification;
    },
    get_useraddresses (state) {
        return state.user.addresses;
    },
	get_basket (state) {
        return state.basket;
    },
	get_loadingdeliveryaddress (state) {
		return state.loadingdeliveryaddress;
	},
	get_loadingpostcodes (state) {
		return state.loadingpostcodes;
	},
	get_loadingdenominations (state) {
		return state.loadingdenominations;
	},
	get_loadingcourses (state) {
		return state.loadingcourses;
	},
	get_loadingsubscriptions (state) {
		return state.loadingsubscriptions;
	},
	get_checkinggiftcardbalance (state) {
		return state.checkingGiftcardBalance;
	},
	get_giftcardbalance (state) {
		return state.giftcardBalance;
	},
	get_mygiftcards (state) {
		return state.mygiftcards;
	},
	get_mycourses (state) {
		return state.mycourses;
	},
	get_mysubscriptions (state) {
		return state.mysubscriptions;
	},
	get_loadingmysubscriptions (state) {
		return state.loadingmysubscriptions;
	},
	get_recommendations (state) {
		return state.recommendations;
	},
	get_pastproducts (state, data) {
		return state.pastproducts;
	},
	get_loadingbookingavailability (state) {
		return state.loadingbookingavailability;
	},
	get_checkingavailability (state) {
		return state.checkingAvalability;
	},
	getPlatformDetails () {
	    return state.platformDetails;
	},
	get_bouncebasket () {
		return state.bounceBasket;
	},
	get_loadingsalonreviews () {
		return state.loadingsalonreviews;
	},
	get_salonreviews () {
		return state.salonreviews;
	},
	get_categories () {
		return state.categories;
	},
	get_brands () {
		return state.brands;
	},
	get_subbrands () {
		return state.subbrands;
	},
	get_pricerangelimits () {
		return state.priceRangeLimits;
	},
	get_services () {
		return state.services;
	},
	get_loadingservices () {
		return state.loadingservices;
	},
	get_servicecategories () {
		return state.servicecategories;
	},
	get_coursescategories () {
		return state.coursescategories;
	},
	get_loadingteammembers () {
		return state.loadingteammembers;
	},
	get_teammembers () {
		return state.teammembers;
	},
	get_loadingdatestatus () {
		return state.loadingdatestatus;
	},
	get_temporarydata () {
		return state.temporaryData;
	},
	get_loadingcharge () {
		return state.loadingcharge;
	},
	get_shopmessage () {
		return state.parameters.BannerMessageShop;
	},
	get_subscriptionsmessage () {
		return state.parameters.BannerMessageSubscriptions;
	},
	get_coursesmessage () {
		return state.parameters.BannerMessageCourse;
	},
	get_giftcardsmessage () {
		return state.parameters.BannerMessageGiftCard;
	},
	get_bookmessage () {
		return state.parameters.BannerMessageBook;
	},
	get_desiredpage () {
        return state.desiredPage;
    },
	get_questionsloading () {
		return state.loadingQuestions;
	},
	get_loadingupgrades () {
		return state.loadingUpgrades;
	},
	get_questionsdata () {
		return state.questionsdata;
	},
	get_upgrades (state, params) {
		return state.upgrades;
	},
	get_loadingwrongquestions () {
		return state.loadingWrongQuestions;
	},
	get_bookings () {
		return state.bookings;
	},
	get_loadingbookings () {
		return state.loadingBookings;
	},
	get_loadingpromocode () {
		return state.loadingPromocode;
	},
	get_validatingnewgiftcard () {
		return state.validatingNewGiftcard;
	},
	get_tags () {
		return state.tags
	},
	get_bookingrequiredfields () {
		return state.bookingrequiredfields;
	},
	get_headerconfig () {
		return typeof state.urlParams.tabs == "undefined" ? "all" : state.urlParams.tabs;
	},
	get_prepopulatedgiftcards () {
		return state.parameters.Prepopulate.filter( (entry) => entry.Type == 3 );
	},
	get_prepopulatedproducts () {
		return state.parameters.Prepopulate.filter( (entry) => entry.Type == 4 );
	},
	get_prepopulatedservices () {
		var services = state.parameters.Prepopulate.filter( (entry) => entry.Type == 2 );
		return services;
	},
	get_prepopulatedcourses () {
		var services = state.parameters.Prepopulate.filter( (entry) => entry.Type == 6 );
		return services;
	},
	get_prepopulatedsubscriptions () {
		var services = state.parameters.Prepopulate.filter( (entry) => entry.Type == 8 );
		return services;
	},
	get_prepopulatedteammember () {
		var services = state.parameters.Prepopulate.filter( (entry) => entry.Type == 9 );
		return services;
	},
	get_prepopulatedklarna () {
		var klarna = state.parameters.Prepopulate.filter( (entry) => entry.Type == 5 )[0];
		klarna["isCourse"] = false;
		var entries = [];
		if(typeof klarna.Data.Giftcard != "undefined") {
			klarna.Data.Giftcard.forEach((item, i) => {
				item["class"] = "giftcard";
				entries.push(item);
			});
		}
		if(typeof klarna.Data.Services != "undefined") {
			klarna.Data.Services.forEach((item, i) => {
				item["class"] = "service";
				entries.push(item);
			});
		}
		if(typeof klarna.Data.Products != "undefined") {
			klarna.Data.Products.forEach((item, i) => {
				item["class"] = "product";
				entries.push(item);
			});
		}
		if(typeof klarna.Data.Error != "undefined") {
			klarna.Data.Error.forEach((item, i) => {
				item["class"] = "error";
				entries.push(item);
			});
		}
		if(typeof klarna.Data.Courses != "undefined") {
			klarna.isCourse = true;
			var item = {
				description: klarna.Data.Description,
				price: klarna.Data.FixedPrice,
				class: "course"
			}
			entries.push(item);
		}
		klarna["Entries"] = entries;

		return klarna;
	},
	get_forcedteammember () {
		return state.forcedTeammember;
	},
	get_tmrecommendation () {
		return state.tmrecommendation;
		//return state.parameters.Prepopulate.filter( (entry) => entry.Type == 1 )[0];
	},
	get_gcspid () {
		return state.parameters.gcspid;
	},
	get_klarnacallbackflow () {
		return state.klarnaCallbackFlow;
	},
	get_chosencourse () {
		return state.chosenCourse;
	},
	get_chosensubscription () {
		return state.chosenSubscription;
	},
	get_stripeclientsecret () {
		return state.stripeClientSecret;
	},
	get_gatrackingid () {
        return state.parameters.GATrackingID;
    },
    get_gatrackingidsaloniq () {
        return state.parameters.GATrackingIDSalonIQ;
    },
    get_cdindexteammember () {
        return state.parameters.CDIndex_Teammember;
    },
	get_klarnabuttontext () {
		return state.klarnaButtonText;
	},
	get_klarnaenabled () {
		return state.isKlarnaEnabled;
	},
	get_validgiftcards () {
		return state.validGiftcards;
	}
}

const actions = {

	loadQueueModeStatus ({commit,state,dispatch}, data) {
		commit("set_queuemodestatusloading", true);
		axios.post(localPrefix+'/shoponline/GetQueueStatus',{
			salonid: state.selectedSalonID,
			clientid: state.user.id,
			items: data.services,
			tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
        })
		.then( response => {
			commit("set_queuemodestatusloading", false);
			commit("set_queuemodestatus", response.data.Data);
            data.callback(response.data);
	    })
	},

	joinQueue ({commit,dispatch}, data) {
		commit("set_loadingqueuemodestuff", true);
		axios.post(localPrefix+'/shoponline/AddtoQueue',{
			clientid: state.user.id,
			salonid: state.selectedSalonID,
			items: JSON.stringify({services:data.services}),
			notes: data.notes,
			promocode: data.promocode,
			tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
        })
		.then( response => {
			commit("set_loadingqueuemodestuff", false);
            data.callback(response.data);
	    })
	},

	leaveQueue ({commit,dispatch}, data) {
		commit("set_loadingqueuemodestuff", true);
		axios.post(localPrefix+'/shoponline/DeleteFromQueue',{
			clientid: state.user.id,
			standbyitemid: data.standbyitemid,
			tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
        })
		.then( response => {
			commit("set_loadingqueuemodestuff", false);
            data.callback(response.data);
	    })
	},

	applyQueueModePromocode ({commit,dispatch}, data) {
		commit("set_queuemodepromocodeloading", true);
		axios.post(localPrefix+'/shoponline/ValidateQPromo',{
			clientid: state.user.id,
			salonid: state.selectedSalonID,
			items: JSON.stringify({services:data.services}),
			promocode: data.promocode,
			tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
        })
		.then( response => {
			commit("set_queuemodepromocodeloading", false);
            data.callback(response.data);
	    })
	},

	addToWaitingList ({commit,dispatch}, data) {
		commit("set_addingtowaitinglist",true);
        axios.post(localPrefix+"/shoponline/SaveOnlineWaitingList",{
			clientid: data.clientid,
			salonid: state.selectedSalonID,
			waitingdate: data.waitingdate,
			items: data.items
        })
        .then(response => {
			commit("set_addingtowaitinglist",false);           
			if(typeof data.callback == "function") data.callback(response.data);
        });
    },

	erasePrepopulatedData ({ commit, state, dispatch }, type) {
		var idx = state.parameters.Prepopulate.findIndex( (entry) => entry.Type == type );
		if(idx > -1) {
			state.parameters.Prepopulate.splice(idx,1);
		}
	},

    onResize ({ commit, state, dispatch }, data) {
        commit("set_resizeparams", data);
    },

    loadFriends ({ commit, state, dispatch }, data) {
      axios.post(url,{'data':JSON.stringify(data)})
      .then(function(response) {
        commit("set_friends", response.data.Data);
      });
    },
    loadUser ({ commit, state, dispatch }, data) {
      axios.post(url,{'data':JSON.stringify(data)})
      .then(function(response) {
        commit("set_user", response.data.Data);
      });
    },
    setURLParams({commit,state},data) {
		var getURLFromURLParams = function(origParams) {
			var params = "";
			var keys = Object.keys(origParams);
			for(var i=0; i<keys.length; i++) {
				params += keys[i] + "=" + origParams[keys[i]] + "&";
			}
			params = params.substr(0,params.length-1);
			return window.location.origin + window.location.pathname + "?" + params;
		}

      	commit("set_urlparams", data);
	  	if(typeof state.urlParams.salonid != "undefined") {
			state.originalSalonID = state.urlParams.salonid;
			commit("set_selectedSalonID",state.urlParams.salonid);
		}
		// klarna callback
	  	if( typeof state.urlParams.klarnaID != "undefined" || ( (typeof state.urlParams.payment_intent != "undefined") && (typeof state.urlParams.payment_intent_client_secret != "undefined") ) ) {
			commit("set_klarnacallbackflow",true);
			let paramsToSend = JSON.parse(JSON.stringify(state.urlParams));
			paramsToSend["klarna"] = JSON.stringify(paramsToSend);
			delete paramsToSend.klarnaID;
			delete paramsToSend.payment_intent;
			delete paramsToSend.payment_intent_client_secret;
			delete paramsToSend.redirect_status;
			delete paramsToSend.source_type;
			commit( "set_urlparams", JSON.parse(JSON.stringify(paramsToSend)) );
			let paramsCopy = JSON.parse(JSON.stringify(paramsToSend));
			delete paramsCopy.klarna;
	  		history.replaceState('', 'BookingPortal', getURLFromURLParams(paramsCopy));
		} else {
			commit("set_klarnacallbackflow",false);
		}
    },
    setBasketOn({commit},data) {
        commit("set_basketon",data);
    },
	saveTemporaryData({commit,state,dispatch},data) {
		var found = state.temporaryData.find( (a) => {
			return a.name == data.name
		});
		if(typeof found != "undefined") {
			found.value = data.value;
		} else {
			state.temporaryData.push(data);
		}
	},
	removeTemporaryData({commit,state,dispatch},data) {
		var found = state.temporaryData.findIndex( (a) => {
			return a.name == data.name
		});
		if(found > -1) {
			state.temporaryData.splice(found,1);
		}
	},
    changePassword ({commit,dispatch}) {
		commit("set_authenticated", false);
        commit('set_authenticating',false);
        dispatch("deleteUserIDCookie");
        axios.post(localPrefix+"/shoponline/Changemypass",{
            tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
        })
        .then(data => {
            if (data.data.Status == "Success") {
                dispatch("showNotification",{message:"Email has been sent.",style:{'background-color':"lawngreen"},timeout:2000});
            } else {
                dispatch("showNotification",{message:"Error sending email.",style:{'background-color':"red",color:"white"},timeout:2000});
              //SalonIQWidget2.$ons.notification.toast("Parameters failed to load. Can not continue.", { timeout: 1000, animation: 'ascend' })
          	}
		  	//callback(data.data);
        });
    },
	loadParameters ({commit,state,dispatch}) {
        var obj = JSON.parse(JSON.stringify(state.urlParams));
        obj["tenantInfo"] = JSON.stringify(getTenantInfoForRequest({userid: state.user.id}));
        axios.post(localPrefix+"/shoponline/GetParameters",obj)
        .then(data => {
            if (data.data.Status == "Success") {

				// make sure GA4ID is in the data so we can set it for global analytics sending
				if(typeof data.data.Data.GA4ID == "undefined") {
					data.data.Data["GA4ID"] = "";
				}

			// commit("set_klarnacallbackflow",true);
			// data.data.Data.Prepopulate = [
			// 	{
			// 		Data: {
			// 			Giftcard: [
			// 				{
			// 					Address1: "19 Mount Ephraim Road",
			// 					Address2: "",
			// 					County: "Kent",
			// 					DenominationID: "c028fc6d-7812-4433-bd91-eac732c27851",
			// 					FirstName: "David",
			// 					FromName: "David Kopnicky",
			// 					LastName: "Kopnicky",
			// 					PersonalMessage: "",
			// 					Postcode: "TN1 1EN",
			// 					ToName: "",
			// 					Toemail: "",
			// 					Town: "Tunbridge Wells",
			// 					itemsdescription: "Giftcard worth £25.00 for £25.00 X  @ £25.00"
			// 				},
			// 				{
			// 					Address1: "19 Mount Ephraim Road",
			// 					Address2: "",
			// 					County: "Kent",
			// 					DenominationID: "c028fc6d-7812-4433-bd91-eac732c27851",
			// 					FirstName: "David",
			// 					FromName: "David Kopnicky",
			// 					LastName: "Kopnicky",
			// 					PersonalMessage: "",
			// 					Postcode: "TN1 1EN",
			// 					ToName: "",
			// 					Toemail: "",
			// 					Town: "Tunbridge Wells",
			// 					itemsdescription: "Giftcard worth £25.00 for £25.00 X  @ £25.00"
			// 				}
			// 			],
			// 			Status: "succeeded"
			// 		},
			// 		Type: 5
			// 	}
			// ];

				// start of debug data
				// commit("set_klarnacallbackflow",true);
				// data.data.Data.ShowCourses = true;
				//
				// data.data.Data.Prepopulate = [{
				// 	Data: {
				// 		SubscriptionID: "79cd03c8-a1e5-ed11-8e8d-002248433a7a",
				// 		Description: "",
				// 		FixedPrice: 149,
				// 		Status: true
				// 	},
				// 	Type: 8
				// }];

				// commit("set_klarnacallbackflow",true);
				// data.data.Data.Prepopulate = [{
				// 	Data: {
				// 		Error: [{
				// 			Message: "Yeeehaaaa"
				// 		}],
				// 		Status: false
				// 	},
				// 	Type: 5
				// }];

				//data.data.Data.KlarnaShop = true;
				//data.data.Data.ForceSalonChoice = true;
				// data.data.Data.LoginRequired = true;
				//data.data.Data.EnableGroupSuppliers = false;
				// data.data.Data.GiftcardOtherCharge1Description = "gergtre re thrthrt rth rthr trh  ger g";
				// data.data.Data.GiftcardOtherCharge1 = 5;
				//data.data.Data.SalonImageLink = "https://terencepaul.com/uploads/sliders/didsbury-hairdressing-salon-28.jpg";
				//data.data.Data.PrepopulateData.DenominationID = "df043a0a-cbef-48b3-8dca-476aabe4fc33";
				//data.data.Data.PrepopulateData.ProductID = "vue 4c6fec3d-021a-49f9-b9c1-125d30e45cb2";

				//data.data.Data.EnableShopStockCheck = true;
				//data.data.Data.SellProductsOnline = true;
				//data.data.Data.ThankYouPage = "https://www.google.com?id=1";

				//data.data.Data.Online_SelectServiceFirst = false;
				//data.data.Data.ShowSubscriptions = true;
				//data.data.Data.GCID = "5475189520";

				//data.data.Data.ClientRules.AgeGroupRequired_Booking = true;
				//data.data.Data.EnableGiftcardPaymentOnline = true;

				//data.data.Data.ShowServiceImageOnline = true;
				//end of debug data

				var klarna = data.data.Data.Prepopulate.find( (entry) => entry.Type == 5 );
				if(typeof klarna != "undefined" && typeof klarna.Data != "undefined" && typeof klarna.Data.Products != "undefined") {
					if(klarna.Data.Status) dispatch("eraseBasket");
				}

				var servicesEntry = data.data.Data.Prepopulate.find( (entry) => entry.Type == 2 );
				if(typeof servicesEntry != "undefined") {
					servicesEntry.Data.Package.forEach( (item, i) => {
						item["TeamMemberId"] = item.TeamMemberid == 0 ? "00000000-0000-0000-0000-000000000000" : item.TeamMemberid;
						item["Bookingserviceid"] = item.Serviceid;
						item["TeamMember"] = item.TeamMemberName;
						item["TMImageURL"] = item.ImageLink;
						delete item.Serviceid;
					});
					dispatch("saveTemporaryData",{name:"rebook_services",value:JSON.stringify({ services: servicesEntry.Data.Package, Date: servicesEntry.Data.Date*1000, Type:2 })});
					var idx = data.data.Data.Prepopulate.findIndex( (entry) => entry.Type == 2 );
					data.data.Data.Prepopulate.splice(idx,1);
				}

				var servicesEntry = data.data.Data.Prepopulate.find( (entry) => entry.Type == 10 );
				if(typeof servicesEntry != "undefined") {
					servicesEntry.Data.Package.forEach( (item, i) => {
						item["TeamMemberId"] = item.TeamMemberid == 0 ? "00000000-0000-0000-0000-000000000000" : item.TeamMemberid;
						item["Bookingserviceid"] = item.Serviceid;
						item["TeamMember"] = item.TeamMemberName;
						item["TMImageURL"] = item.ImageLink;
						delete item.Serviceid;
					});
					dispatch("saveTemporaryData",{name:"rebook_services",value:JSON.stringify({ services: servicesEntry.Data.Package, Date: servicesEntry.Data.Date*1000, Type:10 })});
					var idx = data.data.Data.Prepopulate.findIndex( (entry) => entry.Type == 10 );
					data.data.Data.Prepopulate.splice(idx,1);
				}

				

				commit("set_parameters", data.data.Data);

				// thank you page url paramsToSend
				let thankyoupageParamsToSend = {};
				if(state.parameters.ThankYouPage != "") {
					let parsToCheck = ["_ga","utm_source","utm_medium","utm_campaign","utm_content"];
					let pars = [];
					parsToCheck.forEach( (item) => {
						if(typeof state.urlParams[item] != "undefined") {
							pars.push(item + "=" + state.urlParams[item]);
						}
					});
					state.trackingParamsString = pars.join("&");
					if(pars.length>0) {
						state.parameters.ThankYouPage += "/?" + state.trackingParamsString;
					}
				}

				// set colours
				var color = typeof data.data.Data.ButtonColor != "undefined" ? data.data.Data.ButtonColor : "#079F90";
				document.documentElement.style.setProperty("--button-color",color);
				document.documentElement.style.setProperty("--button-color-light",tinycolor(color).lighten(10).toString());
				document.documentElement.style.setProperty("--button-color-transparent",tinycolor(color).setAlpha(0.5).toString());
				document.documentElement.style.setProperty("--banner-color",data.data.Data.BannerMessageShopColour);
				commit("set_userid", data.data.Data.clientid);
				state.filters.find( function(a) {return a.id=="favourite"} ).selected = state.parameters.EnableFavFilter;

				// if GCID is supplied, redirect to giftcards if possible
				if(state.parameters.GCID != "") {
					state.urlParams["tab"] = "giftcards";
				}

				var doRoute = typeof state.urlParams.tab != "undefined";
				var path = "shop";



				if(doRoute) {
					if(state.parameters.OnlineGCSaleType == 0 && state.urlParams.tab == "giftcards") doRoute = false;
					if(state.parameters.Showbook == false && state.urlParams.tab == "book") doRoute = false;
					if(state.parameters.SellProductsOnline == false && state.urlParams.tab == "shop") doRoute = false;
				}
				if(doRoute) {
					path = state.urlParams.tab;
				}
				else {
					if(state.parameters.SellProductsOnline == false) {
						if(state.parameters.Showbook == true) {
						  path = "book";
						} else {
						  path = "contact";
						}
					}
				}

				// GA tracking start
				var gaTrackingDomains = state.parameters.GACrossTrackingDomains.split(",");
				gtag('config', state.parameters.GA4IDSalonIQ, {/*'debug_mode': true,*/linker:{domains:gaTrackingDomains}} );
				gtag('config', state.parameters.GATrackingIDSalonIQ, JSON.parse(JSON.stringify(state.gaConfigCustomDimensionsObjectSalonIQ)) );
				if(state.parameters.GA4ID != "") {
					gtag('config', state.parameters.GA4ID, {linker:{domains:gaTrackingDomains}} );
				} else {
	                if(state.parameters.GATrackingID != "") {
						// we need to custom build this object for tenant as their indices may differ
						state.gaConfigCustomDimensionsObject.custom_map["dimension"+  state.parameters.CDIndex_Salon] = "salon";
						state.gaConfigCustomDimensionsObject.custom_map["dimension"+  state.parameters.CDIndex_Teammember] = "teammember";
						state.gaConfigCustomDimensionsObject.custom_map["dimension"+  state.parameters.CDIndex_Widget] = "widget";
						state.gaConfigCustomDimensionsObject.custom_map["dimension"+  state.parameters.CDIndex_Purchase] = "purchase";
	                    state.gaConfigCustomDimensionsObject.linker.domains = gaTrackingDomains;
						var obj = JSON.parse(JSON.stringify(state.gaConfigCustomDimensionsObject));
	                    obj['cookie_flags'] = 'max-age=7200;secure;samesite=none';
						gtag('config', state.parameters.GATrackingID, obj);
					}
				}
                // GA tracking end
				// FBPixel start
				if(state.parameters.FBPixelID != "") {
					fbq('init', state.parameters.FBPixelID);
				    fbq('track', 'PageView');
				}
				// FBPixel end


				dispatch("rehydrateBasket");
				dispatch("loadSalons");
				dispatch("startFBApp");
				//dispatch("setStripeInstance",state.parameters.spid);
				// state.stripeInstance = state.parameters.spid == "" ? Stripe(state.parameters.MyStripePublishableKey) : Stripe(state.parameters.MyStripePublishableKey,{stripeAccount: state.parameters.spid});
				state.accountCode = data.data.Message;

				var products = data.data.Data.Prepopulate.filter( (entry) => entry.Type == 1 );
				if( products.length > 0) {
					commit("set_desiredpage","checkout");
					if(!state.parameters.LoggedIn) path = "user";
					commit("set_tmrecommendation",products[0].Data);
					for(var i=0; i<products[0].Data.Products.length; i++) {
					  dispatch("addItemToBasket",{
						  type: 3,
		                  data: {
		                      showDetails: false,
		                      product: JSON.parse(JSON.stringify(products[0].Data.Products[i])),
		                      quantity: 1
		                  }
					  })
					}
				}

				if(state.urlParams.tab == "consent") {
					path = "user";
					commit("set_desireddata",{page:"user",params:{action:"showConsent", scrollTo: "consent"}});
				}

				// var giftcards = data.data.Data.Prepopulate.filter( (entry) => entry.Type == 3 );
				// if(giftcards.length>0) {
				// 	console.log(111);
				// 	commit("set_desiredpage","giftcards");
				// 	if(!state.parameters.LoggedIn) path = "user";
				// }
				// console.log(BookingPortal.$route.name,path);
				if(BookingPortal.$route.name != path) BookingPortal.$router.replace(path);
            } else {
            	dispatch("showNotification",{message:"Loading parameters failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
          	}
        });
    },
	setStripeInstance({commit,state,dispatch},spid) {
		state.stripeInstance = spid == "" ? Stripe(state.parameters.MyStripePublishableKey) : Stripe(state.parameters.MyStripePublishableKey,{stripeAccount: spid});
	},
    loadSalons ({commit,state,dispatch}) {
        axios.post(localPrefix+"/shoponline/GetSalons",{})
        .then(data => {
			//data.data.Status = "Fail";
			//data.data.Data.Salons[1].AnonymousMode = true;
            if (data.data.Status == "Success") {
				//data.data.Data.Salons[1].KlarnaPayments = true;
				// data.data.Data.Salons = data.data.Data.Salons.concat(data.data.Data.Salons);
				// data.data.Data.Salons = data.data.Data.Salons.concat(data.data.Data.Salons);
				// data.data.Data.Salons = data.data.Data.Salons.concat(data.data.Data.Salons);

				//data.data.Data.Salons.forEach((item, i) => {
				//	item.QueueMode = true;
				//});

				var found = data.data.Data.Salons.find( salon => salon.Showbook == true );
				if(typeof found == "undefined") {
					console.log("No salons enabled for online bookings, disabling BOOK tab...");
					state.parameters.Showbook = false;
					if(BookingPortal.$router.currentRoute.name == "book") {
						console.log("No salons enabled for online bookings but current path is BOOK, redirecting to CONTACT...");
						BookingPortal.$router.replace("contact");
					}
				}

                commit("set_salons",data.data.Data);
				found = data.data.Data.Salons.find( salon => salon.ID == data.data.Data.DefaultSalonId );
				if(typeof found != "undefined") {
					document.title=state.parameters.TenantName+"-"+found.Name;
					commit("set_selectedSalonID",data.data.Data.DefaultSalonId); 
				} else {
					commit("set_selectedSalonID",data.data.Data.Salons[0].ID);
				}
                commit("set_loadingsalons", false);
                if(state.parameters.LoggedIn) {
                    commit("set_authenticated",true);
					dispatch("saveUserIDCookie");
                    dispatch("loadUserDetails",true);
                } else {
                    commit("set_initialising", false);
					if( (state.desiredPage != "checkout" && state.desiredPage != "user") || state.parameters.LoggedIn) {
	                    if(BookingPortal.$router.currentRoute.name != state.desiredPage && state.desiredPage!='') { BookingPortal.$router.replace(state.desiredPage); }
	                    commit("set_desiredpage","");
	                }
                }
            } else {
				dispatch("showNotification",{message:"Loading salons failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
          	}
        });
    },
    loadProducts ({commit,state,dispatch},params) {
        axios.post(localPrefix+"/shoponline/GetOnlineProducts",{ salonid: state.parameters.ProductsSalonID })
        .then(data => {
            if (data.data.Status == "Success") {
                commit("set_products",data.data.Data);
                commit("set_loadingproducts", false);
            } else {
				dispatch("showNotification",{message:"Loading products failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
			}
			if(typeof params.callback == "function") params.callback(data.data);
        });
    },
	checkProductAvailability ({commit,state,dispatch},params) {
		if(params.productids == "") return;
		commit("set_checkingproductavailability", true);
        axios.post(localPrefix+"/shoponline/GetProductStocks",{ productids: params.productids, salonid: state.parameters.ProductsSalonID })
        .then(data => {
            if (data.data.Status == "Success") {
            } else {
				dispatch("showNotification",{message:"Loading product availability failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
			}
			commit("set_checkingproductavailability", false);
			if(typeof params.callback == "function") params.callback(data.data);
        });
    },
	loadDenominations ({commit,state,dispatch},data) {
		commit("set_loadingdenominations", true);
        axios.post(localPrefix+"/shoponline/GetmyDenominations",{})
        .then(response => {
            if (response.data.Status == "Success") {
				//response.data.Data.Denomination[0].DMImageURL = "https://cdn.pixabay.com/photo/2021/08/25/20/42/field-6574455__340.jpg";
                commit("set_denominations",response.data.Data);
            } else {
				dispatch("showNotification",{message:response.data.Message,style:{'background-color':"red",color:"white"},timeout:3000});
          	}
			data.callback(response);
		  commit("set_loadingdenominations", false);
        });
    },	
	loadCourses ({commit,state,dispatch},data) {
		commit("set_loadingcourses", true);
        axios.post(localPrefix+"/shoponline/GetCourses",{ salonid: state.selectedSalonID })
        .then(response => {
            if (response.data.Status == "Success") {
                commit("set_courses",response.data.Data);
            } else {
				dispatch("showNotification",{message:"Loading courses failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:3000});
          	}
			data.callback(response);
		  commit("set_loadingcourses", false);
        });
    },
	loadSubscriptions ({commit,state,dispatch},data) {
		commit("set_loadingsubscriptions", true);
        axios.post(localPrefix+"/shoponline/GetActiveSubscriptions",{ salonid: state.selectedSalonID })
        .then(response => {
            if (response.data.Status == "Success") {
                commit("set_subscriptions",response.data.Data);
            } else {
				dispatch("showNotification",{message:"Loading subscriptions failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:3000});
          	}
			data.callback(response);
		  commit("set_loadingsubscriptions", false);
        });
    },
    loadExistingCards ({commit,state,dispatch},params) {
        axios.post(localPrefix+"/shoponline/getStripeAllCards",{ clientid: state.user.id })
        .then(data => {
            if (data.data.Status == "Success") {
                commit("set_existingcards",data.data.Data.Cards);
            } else {
          }
        });
    },
	loadSalonReviews ({commit,state,dispatch},params) {
		commit("set_loadingsalonreviews", true);
        axios.post(localPrefix+"/shoponline/GetsalonReviews",{ salonid: state.selectedSalonID, page: params.page })
        .then(data => {
			commit("set_loadingsalonreviews", false);
            if (data.data.Status == "Success") {
                commit("set_salonreviews",data.data.Data);
            } else {
			}
        });
    },
	loadCharge ({commit,state,dispatch},params) {
		commit("set_loadingcharge", true);
        axios.post(localPrefix+"/shoponline/GetDepositAmount",{
			items: params.items,
			upgrades: params.upgrades,
			promocode: params.promocode,
			queuemode: params.queuemode
		}).then(data => {
			//data.data.Status = "Fail";
			//console.log(data.data);
			// data.data.Data.DepositAmount = 76;
			// data.data.Data.FullAmount = 153;
			// data.data.Data.ShowKlarnaButton = true;
			//data.data.Data.IsSetupFlow = true;
			
			if (data.data.Status == "Success") {
				state.klarnaButtonText = data.data.Data.KlarnaText;
				state.isKlarnaEnabled = data.data.Data.ShowKlarnaButton;				
            } else {
				dispatch("showNotification",{message:"Loading charge failed. "+data.data.Message,style:{'background-color':"red",color:"white"},buttonLabel:"RETRY",callback:BOOK.loadCharge,timeout:0});
			}
			params.callback(data.data);
			commit("set_loadingcharge", false);
        });
		// .catch(error => {
		// 	dispatch("showNotification",{message:"System error. Please reload. (ERROR:getdepositamount)",style:{'background-color':"red",color:"white"},timeout:0});
		// 	commit("set_loadingcharge", false);
		// });
    },
	applyPromocode ({commit,state,dispatch},params) {
		commit("set_loadingpromocode", true);
        axios.post(localPrefix+"/shoponline/CheckPromocode",params)
        .then(data => {
			commit("set_loadingpromocode", false);
			params.callback(data.data);
            if (data.data.Status == "Success") {
            } else {
				dispatch("showNotification",{message:"Applying promocode failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:3000});
			}
        });
    },
	validateNewGiftcard ({commit,state,dispatch},params) {
		commit("set_validatingnewgiftcard", true);
        axios.post(localPrefix+"/shoponline/ValidateGiftCards",params)
        .then(data => {
			commit("set_validatingnewgiftcard", false);
			params.callback(data.data);
            if (data.data.Status == "Success") {
            } else {
				dispatch("showNotification",{message:"Gift card validation failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:3000});
			}
        });
    },
	loadQuestions({ commit,dispatch }, data1) {
		commit("set_questionsloading", true);
        axios.post(localPrefix+"/shoponline/IsSkinTestRequired",data1)
        .then(data => {
            if (data.data.Status == "Success") {
				commit("set_questionsdata",data.data.Data);
            } else {
				dispatch("showNotification",{message:"Questions failed to load. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
			}
			data1.callback(data.data);
            commit("set_questionsloading", false);
        }).catch(error => {
			//console.log(error);
			dispatch("showNotification",{message:"System error. Please reload. (ERROR:loadingquestions)",style:{'background-color':"red",color:"white"},timeout:2000});
			commit("set_questionsloading", false);
		});
	},
	loadUpgrades({ commit,dispatch }, data1) {
		commit("set_loadingupgrades", true);
        axios.post(localPrefix+"/shoponline/GetUpgrades",data1)
        .then(data => {

			// data.data.Status = "Fail";
			// data.data.Message = "new client";

            if (data.data.Status == "Success") {
				data.data.Data.Services.forEach( (item) => item["showDetailedDescription"]=true );
				data.data.Data.Services.sort( (a,b) => b.Price - a.Price );
				commit("set_upgrades",data.data.Data.Services);
				data1.callback(data.data);
            } else {
				if(data.data.Message.toLowerCase().indexOf("new client") > -1) {
					BOOK.makeAnotherBooking();
					dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
				} else {
					dispatch("showNotification",{message:"Upgrades failed to load. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
				}
			}
            commit("set_loadingupgrades", false);
        }).catch(error => {
			console.log(error);
			dispatch("showNotification",{message:"System error. Please reload. (ERROR:loadingupgrades)",style:{'background-color':"red",color:"white"},timeout:2000});
			commit("set_loadingupgrades", false);
		});
	},
	makeBooking ({ commit,dispatch }, data1) {
		commit("set_loading",true);
		commit("set_makebookingloading", true);
        axios.post(localPrefix+"/shoponline/MakeBooking",data1)
        .then(data => {
            if (data.data.Status == "Success") {
				// if (data.data.Data.PaymentSucessfull === true) {
				// 	commit("set_existingcards",data.data.Data.Cards.Cards);
				// 	commit("set_deliveryaddresses",data.data.Data.ClientAddresses);
				// 	commit("set_mygiftcards",data.data.Data.GiftCards);
				// } else {
				// 	dispatch("showNotification",{message:"Payment failed. "+data.data.Data.ErrorMessage,style:{'background-color':"red",color:"white"},timeout:0});
				// }
            } else {
				dispatch("showNotification",{message:"Booking failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            }
			data1.callback(data.data);
            commit("set_makebookingloading", false);
			commit("set_loading",false);
        }).catch(error => {
			//console.log(error);
			dispatch("showNotification",{message:"System error. Please reload. (ERROR:makebooking)",style:{'background-color':"red",color:"white"},timeout:0});
			commit("set_makebookingloading", false);
			commit("set_loading",false);
		});
	},
    // createBookingPayment({ commit,dispatch }, data1) {
	// 	commit("set_paymentsloading", true);
    //     axios.post(localPrefix+"/shoponline/MakeStripePayment",data1)
    //     .then(data => {
    //         if (data.data.Status == "Success") {
	// 			if (data.data.Data.PaymentSucessfull === true) {
	// 				commit("set_existingcards",data.data.Data.Cards.Cards);
	// 				commit("set_deliveryaddresses",data.data.Data.ClientAddresses);
	// 				commit("set_mygiftcards",data.data.Data.GiftCards);
	// 				commit("set_validgiftcards",response.data.Data.ValidGiftCards);
	// 			} else {
	// 				//dispatch("showNotification",{message:"Payment failed. "+data.data.Data.ErrorMessage,style:{'background-color':"red",color:"white"},timeout:0});
	// 			}
    //         } else if (data.data.Status == "Fail") {
	// 			dispatch("showNotification",{message:"Payment failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
    //         } else {
	// 			// requires action, no notification
	// 		}
	// 		data1.callback(data.data);
    //         commit("set_paymentsloading", false);
    //     }).catch(error => {
	// 		//console.log(error);
	// 		dispatch("showNotification",{message:"System error. Please reload. (ERROR:makestripepayment)",style:{'background-color':"red",color:"white"},timeout:2000});
	// 		commit("set_paymentsloading", false);
	// 	});
	// },
	createKlarnaPayment ({ commit,state,dispatch }, data1) {
		commit("set_paymentsloading", true);
        axios.post(localPrefix+"/shoponline/GetKlarnaPaymentintent",data1)
        .then(data => {
            if (data.data.Status == "Success") {

            } else {
				dispatch("showNotification",{message:"Klarna payment failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
				commit("set_paymentsloading", false);
            }
			data1.callback(data.data);
        }).catch(error => {
			//console.log(error);
			dispatch("showNotification",{message:"System error. Please reload. (ERROR:createklarnapayment)",style:{'background-color':"red",color:"white"},timeout:2000});
			commit("set_paymentsloading", false);
		});
	},

	createSubscription ({ commit,state,dispatch }, data1) {
		commit("set_paymentsloading", true);
        axios.post(localPrefix+("/shoponline/SaveClientSubscription"),{data: JSON.stringify(data1.data)})
        .then(data => {
            if (data.data.Status == "Success") {
            } else if (data.data.Status == "Fail") {
				dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            } else {
				// requires action, no notification
			}
			data1.callback(data.data);
            commit("set_paymentsloading", false);
        }).catch(error => {
			if(error.response) {
				dispatch("showNotification",{message:"System error (2). Please reload. (ERROR:saveclientsubscription)",style:{'background-color':"red",color:"white"},timeout:2000});
			}
			commit("set_paymentsloading", false);
		});
	},


	makeGCPayment ({ commit,state,dispatch }, data1) {
		commit("set_paymentsloading", true);
        axios.post(localPrefix+("/shoponline/MakebookingwithGC"),data1.paymentintentdata)
        .then(data => {
            if (data.data.Status == "Success") {
				if(typeof data.data.Data.ValidGiftCards != "undefined") commit("set_validgiftcards",data.data.Data.ValidGiftCards);
            } else if (data.data.Status == "Fail") {
				dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            } else {
			}
			data1.callback(data.data);
            commit("set_paymentsloading", false);
        }).catch(error => {
			if(error.response) {
				dispatch("showNotification",{message:"System error (2). Please reload. (ERROR:processtransactions/processsetupintent)",style:{'background-color':"red",color:"white"},timeout:2000});
			}
			commit("set_paymentsloading", false);
		});
	},


	createPaymentNEW ({ commit,state,dispatch }, data1) {
		commit("set_paymentsloading", true);
        axios.post(localPrefix+(data1.data.setup?"/shoponline/processsetupintent":"/shoponline/processtransactions"),{data: JSON.stringify(data1.data)})
        .then(data => {
            if (data.data.Status == "Success") {
				if(data1.data.setup) commit("set_existingcards",data.data.Data.Cards.Cards);
				if(typeof data.data.Data.ValidGiftCards != "undefined") commit("set_validgiftcards",data.data.Data.ValidGiftCards);
            } else if (data.data.Status == "Fail") {
				dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            } else {
				// requires action, no notification
			}
			data1.callback(data.data);
            commit("set_paymentsloading", false);
        }).catch(error => {
			if(error.response) {
				dispatch("showNotification",{message:"System error (2). Please reload. (ERROR:processtransactions/processsetupintent)",style:{'background-color':"red",color:"white"},timeout:2000});
			}
			commit("set_paymentsloading", false);
		});
	},
	getPaymentIntent({ commit,dispatch }, data1) {
		commit("set_paymentsloading", true);
        axios.post(localPrefix+"/shoponline/CreatePaymentIntent",data1.paymentintentdata)
        .then(data => {
			// data.data.Status = "Fail";
			// data.data.Data = null;
            if (data.data.Status == "Success") {
				commit("set_existingcards",data.data.Data.cards.Cards);
            } else if (data.data.Status == "Fail") {
				dispatch("showNotification",{message:"Payment failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            } else {
				// requires action, no notification
			}
			data1.callback(data.data);
            commit("set_paymentsloading", false);
        }).catch(error => {
			console.log(error);
			dispatch("showNotification",{message:data.data.Message + " System error. Please reload. (ERROR:makestripepayment)",style:{'background-color':"red",color:"white"},timeout:0});
			commit("set_paymentsloading", false);
		});
	},
	updatePaymentIntent({ commit,dispatch }, data1) {
		commit("set_paymentsloading", true);
        axios.post(localPrefix+"/shoponline/UpdatePaymentIntent",{
			clientsecret: data1.clientsecret,
			type: data1.updateData.value.type
		}).then(data => {
            if (data.data.Status == "Success") {

            } else if (data.data.Status == "Fail") {
				dispatch("showNotification",{message:"Payment failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            } else {
				// requires action, no notification
			}
			data1.callback(data.data);
            commit("set_paymentsloading", false);
        }).catch(error => {
			//console.log(error);
			dispatch("showNotification",{message:"System error. Please reload. (ERROR:makestripepayment)",style:{'background-color':"red",color:"white"},timeout:2000});
			commit("set_paymentsloading", false);
		});
	},
	getSetupIntent({ commit,dispatch }, data1) {
		commit("set_paymentsloading", true);
        axios.post(localPrefix+"/shoponline/CreateSetupIntent",data1.paymentintentdata)
        .then(data => {
			// data.data.Status = "Fail";
			// data.data.Data = null;
            if (data.data.Status == "Success") {
				//commit("set_existingcards",data.data.Data.cards.Cards);
            } else if (data.data.Status == "Fail") {
				dispatch("showNotification",{message:"Payment failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            } else {
				// requires action, no notification
			}
			data1.callback(data.data);
            commit("set_paymentsloading", false);
        }).catch(error => {
			//console.log(error);
			dispatch("showNotification",{message:"System error. Please reload. (ERROR:getSetupIntent)",style:{'background-color':"red",color:"white"},timeout:2000});
			commit("set_paymentsloading", false);
		});
	},
    removeStripeCard({ commit,state,dispatch }, data1) {
		commit("set_paymentsloading", true);
		axios.post(localPrefix+"/shoponline/deleteStripeCard",{cardid:data1,clientid:state.user.id})
        .then(data => {
            if (data.data.Status == "Success") {
                //data1.callback(data.data);
                var idx = state.existingcards.findIndex(function(a){ return a.CardID == data1; });
                state.existingcards.splice(idx,1);
				dispatch("showNotification",{message:"Card has been deleted successfully.",timeout:3000});
            } else {
				dispatch("showNotification",{message:"Removing Stripe card failed. "+data.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
            }
            commit("set_paymentsloading", false);
        });
	},
    startFBApp({commit,state}) {
		window.fbAsyncInit = function () {
			FB.init({
				appId: state.parameters.fp,//'1124070711000179',
				cookie: true,  // enable cookies to allow the server to access the session
				xfbml: true,  // parse social plugins on this page
				version: 'v2.12' // use graph api version 2.8
			});
		};
		(function (d, s, id) {
			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s); js.id = id;
			js.src = "//connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));
	},
    login ({commit,getters,dispatch,state}, payload) {
        commit('set_authenticating',true);
        axios.post(localPrefix+"/shoponline/Logmein",{
	        data: JSON.stringify({
				Register: {
						Email: payload.user.username,
						Password: payload.user.password,
						Faccesstoken: payload.user.fbtoken,
						platformDetails: getters.getPlatformDetails
				}
			}),
	        tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
	    }).then( function (response) {
            if(response.data.Status==="Success") {
                commit("set_userid", response.data.Data.ClientId);
                dispatch("saveUserIDCookie");
                dispatch("loadUserDetails",false);
            } else {
				commit('set_authenticating',false);
                dispatch("showNotification",{message:"Login failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
                //SalonIQWidget2.$ons.notification.toast("Login failed.", { timeout: 1000, animation: 'ascend' });
            }
		})
    },
    logout({commit,dispatch}) {
        commit('set_authenticating',true);
		axios.post(localPrefix+"/shoponline/Logmeout", {
			tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
		}).then(function (response) {
			commit("set_authenticated", false);
            commit('set_authenticating',false);
            dispatch("deleteUserIDCookie");
			location.href = state.parameters.PortalLink;
		})
	},
    register ({commit,getters,dispatch,state}, payload) {
        commit('set_authenticating',true);
        axios.post(localPrefix+"/shoponline/Register",{
	        data: JSON.stringify({
				Register: {
                    FirstName: payload.user.firstname,
                    LastName: payload.user.lastname,
                    Email: payload.user.email,
                    Password: payload.user.password,
                    Mobile: payload.user.mobile,
					CountryCode: payload.user.countrycode,
                    EmailOptout: payload.user.EmailOptout,
                    SmsOptout: payload.user.SmsOptout,
                    TokenID: payload.user.TokenID,
                    platformDetails: getters.getPlatformDetails
				}
			}),
	        tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
	    }).then( function (response) {
            if(response.data.Status==="Success") {
                commit("set_userid", response.data.Data.ClientId);
                dispatch("saveUserIDCookie");
                dispatch("loadUserDetails",false);
            } else {
				if(response.data.Message.indexOf("new password") != -1) {
					dispatch("showNotification",{message:response.data.Message,forgotpwd:true,style:{'background-color':"red",color:"white"},timeout:0});
				} else {
                	dispatch("showNotification",{message:response.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
				}
				commit('set_authenticating',false);
            }
		})
    },


    setMissingDetails({commit,getters,dispatch,state}, payload) {
        commit('set_authenticating',true);
        axios.post(localPrefix+"/shoponline/GetMissingdetails", {
            data: JSON.stringify({ Missingdetails: payload.user }),
            tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
        }).then(function (response) {
            commit('set_authenticating',false);
            commit("set_showmissingdetails",response.data.Status != "Success");
            if(response.data.Status == "Success") {
				state.user.details.Mobile = payload.user.Mobile;
				state.user.details.Reminderoptout = payload.user.EmailOptout;
				state.user.details.SmsOptout = payload.user.SmsOptout;
			} else {
                commit("set_missingdetailserror",response.data.Message);
            }
        })
	},


    forgotPassword({commit,getters,dispatch,state}, payload) {
		commit("set_loading",true);
		axios.post(localPrefix+"/shoponline/ForgotPassword/", {
			Username: payload.user.email,
			tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
		}).then(function (response) {
            if(response.data.Status=="Success"){
                dispatch("showNotification",{message:"Email has been sent.",style:{'background-color':"lawngreen"},timeout:2000});
				payload.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Error. Email not sent. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            }
			commit("set_loading",false);
		}).catch(function (response) {
			commit("set_loading",false);
            dispatch("showNotification",{message:"System error. Please reload. (ERROR:forgotpassword)",style:{'background-color':"red",color:"white"},timeout:2000});
		})
	},

	resetPassword({commit,getters,dispatch,state}, payload) {
		commit("set_loading",true);
		axios.post(localPrefix+"/shoponline/ResetmyPassword/", {
			EmailAddress: payload.user.email,
			Password: payload.user.npassword,
			ResetCode: payload.user.ccode,
			tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
		}).then(function (response) {
            if(response.data.Status=="Success"){
                dispatch("showNotification",{message:"Your password has been changed. Please log in.",style:{'background-color':"lawngreen"},timeout:3000});
				payload.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Error. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            }
			commit("set_loading",false);
		}).catch(function (response) {
			commit("set_loading",false);
            dispatch("showNotification",{message:"System error. Please reload. (ERROR:forgotpassword)",style:{'background-color':"red",color:"white"},timeout:2000});
		})
	},


    loadUserDetails ({commit,state,dispatch},autoLoggedIn) {
        commit("set_loadinguserdetails",true);
		axios.post(localPrefix+'/shoponline/getMyDetails',{
	        tenantInfo: JSON.stringify(getTenantInfoForRequest({userid: state.user.id}))
	    }).then( function (response) {
			commit("set_loadinguserdetails",false);
            if(response.data.Status==="Success") {
				if(state.desiredPage == "") {
					if(autoLoggedIn == false && (typeof state.urlParams.tab == "undefined") ) {
						let targetPage = state.parameters.Showbook ? "book" : "contact";
						if(targetPage == BookingPortal.$router.currentRoute.name) {
							targetPage = "";
						}
						commit("set_desiredpage",targetPage);
					}
				}
				// response.data.Data.Clients[0].IsOnlineBookingsEnabledClient = false;
				// response.data.Data.Clients[0].IsOnlineBookingClientmessage = "oh sod off";
				//response.data.Data.Clients[0].Missingdetails = true;
				// for (var i = 0; i < response.data.Data.Clients[0].Cards.Cards.length; i++) {
				// 	response.data.Data.Clients[0].Cards.Cards[i]["open"] = false;
				// }
				commit("set_existingcards",response.data.Data.Clients[0].Cards.Cards);
                commit("set_userdetails",response.data.Data.Clients[0]);
				commit("set_recommendations",response.data.Data.Recommendations);
				commit("set_pastproducts",response.data.Data.PastProducts);
				commit("set_deliveryaddresses",response.data.Data.ClientAddresses);
				commit("set_mygiftcards",response.data.Data.GiftCards);
				commit("set_validgiftcards",response.data.Data.ValidGiftCards);
				commit("set_mycourses",response.data.Data.Clients[0].Courses);
				if(state.parameters.LoginRequired) {
					//dispatch("chooseSalon", state.salons.find( (a) => a.ID == response.data.Data.Clients[0].HomeSalonId ));
					commit("set_selectedSalonID",response.data.Data.Clients[0].HomeSalonId);
				}
                commit("set_showmissingdetails",response.data.Data.Clients[0].Missingdetails);
				dispatch("loadBookings",{});
				dispatch("loadMySubscriptions",{});
                if(state.parameters.LoggedIn) {
                    commit("set_initialising", false);
                }
				commit('set_authenticating',false);
				commit("set_authenticated",true);
				//console.log(state.desiredPage);

				// if showing book, let's check required fields
				//state.parameters.ClientRules.AgeGroupRequired_Booking = true;
				//state.parameters.ClientRules.GenderRequired_Booking = true;
				if(state.parameters.Showbook) {
					var keys = Object.keys(state.parameters.ClientRules);
					var checkFields = keys.filter( (key) => state.parameters.ClientRules[key] );
					if(checkFields.length>0) {
						var haveToCheck = false;
						checkFields.forEach( (item, i) => {
							if(item == "AgeGroupRequired_Booking" && state.user.details.Byear == 0) haveToCheck = true;
							if(item == "GenderRequired_Booking" && state.user.details.Gender == 0) haveToCheck = true;
							if(item == "MobileRequired_Booking" && state.user.details.Mobile == "") haveToCheck = true;
							if(item == "AddressRequired_Booking" && (state.user.details.Address1==''||state.user.details.Town==''||state.user.details.County==''||state.user.details.Postcode=='')) haveToCheck = true;
						});
						if(haveToCheck) {
							commit("set_bookingrequiredfields",true);
							dispatch("showNotification",{message:"Please enter all required information in user settings.",style:{'background-color':"red",color:"white"},timeout:5000});
						}
					}
				}

                if(state.desiredPage != "" && !state.bookingrequiredfields) {
					if(state.desiredPage != "user") {
                    	BookingPortal.$router.replace({name:state.desiredPage,params:state.desiredParams});
					} else {
						if(BookingPortal.$router.currentRoute.name == state.desiredPage) {
							setTimeout(function(){
								BookingPortal.$router.currentRoute.matched[0].instances.default.doAction(state.desiredParams.action,state.desiredParams.scrollTo);
							},100);
						}
					}
                    commit("set_desiredpage","");
                }
                //setTimeout( () => {

                //},100);
            }
		})
    },


	loadMySubscriptions ({commit,dispatch}, data) {
        commit("set_loadingmysubscriptions",true);
        axios.post(localPrefix+'/shoponline/GetClientSubscriptions',{
            clientid:state.user.id
        }).then( function (response) {
            commit("set_loadingmysubscriptions",false);
            if(response.data.Status == "Success") {
                commit("set_mysubscriptions",response.data.Data.Subscriptions.filter(function(a){return a.Status=="active"}));
				if(typeof data.callback == "function") data.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Loading client subscriptions failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
            }
        })
    },


	loadBookings ({commit,dispatch}, data) {
        commit("set_loadingbookings",true);
        axios.post(localPrefix+'/shoponline/getMyBookings',{
            clientid:state.user.id
        }).then( function (response) {
            commit("set_loadingbookings",false);
            if(response.data.Status == "Success") {
                commit("set_bookings",response.data.Data.Bookings);
				if(typeof data.callback == "function") data.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Loading bookings failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
            }
        })
    },

	cancelBooking ({commit,dispatch}, data) {
        commit("set_loadingbookings",true);
        axios.post(localPrefix+'/shoponline/CancelBooking',{
            bookingid: data.bookingID
        }).then( function (response) {
            commit("set_loadingbookings",false);
            if(response.data.Status == "Success") {
                //commit("set_bookings",response.data.Data.Bookings);
				dispatch("showNotification",{message:response.data.Message,style:{'background-color':"lawngreen"},timeout:3000});
				dispatch("loadBookings",{});
				if(typeof data.callback == "function") data.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Booking cancellation failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            }
        })
    },

	sendBookingEmail ({commit,dispatch}, data) {
        commit("set_loadingbookings",true);
        axios.post(localPrefix+'/shoponline/SendBookingEmail',{
            bookingid: data.bookingID
        }).then( function (response) {
            commit("set_loadingbookings",false);
            if(response.data.Status == "Success") {
                //commit("set_bookings",response.data.Data.Bookings);
				dispatch("loadBookings",{});
				dispatch("showNotification",{message:"Email has been sent.",style:{'background-color':"lawngreen"},timeout:2000});
				if(typeof data.callback == "function") data.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Sending booking email failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
            }
        })
    },

	cancelBookingLine ({commit,dispatch}, data) {
        commit("set_loadingbookings",true);
        axios.post(localPrefix+'/shoponline/CancelBookingLine',{
            thebookingid: data.bookingID,
			thebookinglineid: data.bookinglineid
        }).then( function (response) {
            commit("set_loadingbookings",false);
            if(response.data.Status == "Success") {
                //commit("set_bookings",response.data.Data.Bookings);
				dispatch("loadBookings",{});
				if(typeof data.callback == "function") data.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Booking line cancellation failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
            }
        })
    },

	rebookBookingLine ({commit,dispatch}, data) {
        commit("set_loadingbookings",true);
        axios.post(localPrefix+'/shoponline/RebookBookingLine',{
            thebookingid: data.bookingID,
			thebookinglineid: data.bookinglineid
        }).then( function (response) {
            commit("set_loadingbookings",false);
            if(response.data.Status == "Success") {
                //commit("set_bookings",response.data.Data.Bookings);
				var selectedItems = response.data.Data.Services;
				dispatch("chooseSalon", state.salons.find( (a) => a.ID == selectedItems[0].Salonid ));
				dispatch("saveTemporaryData",{name:"rebook_services",value:JSON.stringify({ services: selectedItems })});
				BookingPortal.$router.replace("book");
				//dispatch("loadBookings",{});
				if(typeof data.callback == "function") data.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Booking line cancellation failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
            }
        })
    },



    saveUserDetails ({commit,dispatch}, data) {
        commit("set_loadinguserdetails",true);
        axios.post(localPrefix+'/shoponline/saveMyDetails',{
            data: JSON.stringify({ Clients : data.data }),
            tenantInfo: JSON.stringify(getTenantInfoForRequest({userid:state.user.id}))
        }).then( function (response) {
            commit("set_loadinguserdetails",false);
            if(response.data.Status == "Success") {
                commit("set_userdetails",state.user.details);
				data.callback(response.data);
				if(state.desiredPage != "") {
                    BookingPortal.$router.replace({name:state.desiredPage,params:state.desiredParams});
                    commit("set_desiredpage","");
                }
                dispatch("showNotification",{message:"User details have been saved successfully.",style:{'background-color':"lawngreen"},timeout:2000});
            } else {
                dispatch("showNotification",{message:"User details save failed. "+response.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
            }
        })
    },


    loadPostcodeLookup ({commit,dispatch}, data) {
		commit("set_postcodelookupresults",{type:1,response:{AddressInfoList:[]}});
		commit("set_loadingpostcodes",true);
        axios.post(localPrefix+'/shoponline/GetAddressesForPostcode',{
            postcode: data.postcode,
            tenantInfo: JSON.stringify(getTenantInfoForRequest())
        }).then( function (response) {
			commit("set_loadingpostcodes",false);
			if(typeof response.data.Status == "undefined") {
            	commit("set_postcodelookupresults",{type:data.type,response:response.data});
				if(typeof data.callback == "function") data.callback(response.data);
			} else {
				dispatch("showNotification",{message:response.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
			}
        })
    },


	saveDeliveryAddress ({commit,dispatch},data) {
		commit("set_loadingdeliveryaddress", true);
        axios.post(localPrefix+'/shoponline/AddnewClientAddress',{
			address1: data.data.Address1,
			address2: data.data.Address2,
			town: data.data.Town,
			county: data.data.County,
            postcode: data.data.Postcode,
            tenantInfo: JSON.stringify(getTenantInfoForRequest())
        }).then( function (response) {
			commit("set_loadingdeliveryaddress", false);
			if(response.data.Status == "Success") {
                commit("set_deliveryaddresses",response.data.Data.ClientAddresses);
            } else {
                dispatch("showNotification",{message:"Failed to save address. " + response.data.Message,style:{"background-color":"red",color:"white"},timeout:2000});
            }
			data.callback(response);
        })
	},


	removeDeliveryAddress ({commit},data) {
		commit("set_loadingdeliveryaddress", true);
        axios.post(localPrefix+'/shoponline/DeleteMyAddress',{
			addressid: data,
            tenantInfo: JSON.stringify(getTenantInfoForRequest())
        }).then( function (response) {
			commit("set_loadingdeliveryaddress", false);
			if(response.data.Status == "Success") {
                commit("set_deliveryaddresses",response.data.Data.ClientAddresses);
            } else {
                dispatch("showNotification",{message:"Failed to remove address." + response.data.Message,style:{"background-color":"red",color:"white"},timeout:2000});
            }
        })
	},


    uploadUserImage ({commit,dispatch}, data) {

        axios({
            method: 'post',
	        url: localPrefix+'/shoponline/ImageUpload/',
	        data: data.fd,
	        config: { headers: {'Content-Type': 'multipart/form-data' }}
	    }).then(function (response) {
            if(response.data.Status == "Success") {
                data.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Failed to upload image.",style:{"background-color":"red",color:"white"},timeout:2000});
            }
	    }).catch(function (response) {
	    })
	},


    getUserIDCookie({ commit, state }) {
		var cookieUserID = getCookie("BP_UID" + state.originalSalonID);
		if (cookieUserID != null) {
			commit("set_userid", cookieUserID);
		}
	},


    saveUserIDCookie({ commit, state }) {
		var date = new Date();
		date.setTime(date.getTime() + (90 * 24 * 60 * 60 * 1000));
		document.cookie = "BP_UID" + state.originalSalonID + "=" + state.user.id + "; expires=" + date.toGMTString();
		//window.parent.postMessage({ type: 10, userid: encodeURIComponent(state.UserID) }, "*");
	},


	deleteUserIDCookie() {
		var date = new Date();
		date.setTime(date.getTime() - (90 * 24 * 60 * 60 * 1000));
		document.cookie = "BP_UID" + state.originalSalonID + "=; expires=" + date.toGMTString();
		//window.parent.postMessage({ type: 11 }, "*");
	},


    getCookieConsentCookie({ commit, state }) {
		var cc= getCookie("BP_cookieconsent");
		commit("set_cookieconsent", cc==null?true:false);
	},


	saveCookieConsent({ commit, state }) {
		var date = new Date();
		date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
		document.cookie = "BP_cookieconsent=true; expires=" + date.toGMTString();
		commit("set_cookieconsent", false);
	},


	removeItemFromBasket({ commit, state, dispatch }, data) {
        commit("remove_item", data);
		dispatch("saveBasket",JSON.stringify(state.basket));
    },

    addItemToBasket({ commit, state, dispatch }, data) {
        commit("add_item", data);
		dispatch("saveBasket",JSON.stringify(state.basket));
    },

	saveBasket({ commit, state, dispatch }, data) {
		localStorage.setItem("BP_basket",JSON.stringify({
			version: state.VERSION_BASKET,
			salonid: state.urlParams.salonid,
			items: state.basket
		}));
    },


    sniffPlatformDetails ({commit}) {
        (function (window) {
            {
                var dataos = [
                    { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
                    { name: 'Windows PC', value: 'Win', version: 'NT' },
                    { name: 'iPhone', value: 'iPhone', version: 'OS' },
                    { name: 'iPad', value: 'iPad', version: 'OS' },
                    { name: 'Kindle', value: 'Silk', version: 'Silk' },
                    { name: 'Android', value: 'Android', version: 'Android' },
                    { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
                    { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
                    { name: 'Macintosh', value: 'Mac', version: 'OS X' },
                    { name: 'Linux PC', value: 'Linux', version: 'rv' },
                    { name: 'Palm', value: 'Palm', version: 'PalmOS' }
                ];


                function matchItem(string, data) {
                    var i = 0,
                        j = 0,
                        html = '',
                        regex,
                        regexv,
                        match,
                        matches,
                        version;

                    for (i = 0; i < data.length; i += 1) {
                        regex = new RegExp(data[i].value, 'i');
                        match = regex.test(string);
                        if (match) {
                            regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
                            matches = string.match(regexv);
                            version = '';
                            if (matches) { if (matches[1]) { matches = matches[1]; } }
                            if (matches) {
                                matches = matches.split(/[._]+/);
                                for (j = 0; j < matches.length; j += 1) {
                                    if (j === 0) {
                                        version += matches[j] + '.';
                                    } else {
                                        version += matches[j];
                                    }
                                }
                            } else {
                                version = '0';
                            }
                            return {
                                name: data[i].name,
                                version: parseFloat(version)
                            };
                        }
                    }
                    return { name: 'unknown', version: 0 };
                }
                var header = [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera];
                var device = matchItem(header.join(), dataos).name;



                var unknown = '-';

                // screen
                var screenSize = '';
                if (screen.width) {
                    var width = (screen.width) ? screen.width : '';
                    var height = (screen.height) ? screen.height : '';
                    screenSize += '' + width + " x " + height;
                }

                //browser
                var nVer = navigator.appVersion;
                var nAgt = navigator.userAgent;
                var browser = navigator.appName;
                var version = '' + parseFloat(navigator.appVersion);
                var majorVersion = parseInt(navigator.appVersion, 10);
                var nameOffset, verOffset, ix;

                // Opera
                if ((verOffset = nAgt.indexOf('Opera')) != -1) {
                    browser = 'Opera';
                    version = nAgt.substring(verOffset + 6);
                    if ((verOffset = nAgt.indexOf('Version')) != -1) {
                        version = nAgt.substring(verOffset + 8);
                    }
                }
                else if ((verOffset = nAgt.indexOf('OPR')) != -1) {
                    browser = 'Opera';
                    version = nAgt.substring(verOffset + 4);
                }
                    // MSIE
                else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
                    browser = 'Microsoft Edge';
                    version = nAgt.substring(verOffset + 5);
                }
                else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
                    browser = 'Microsoft Internet Explorer';
                    version = nAgt.substring(verOffset + 5);
                }
                    // Chrome
                else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
                    browser = 'Chrome';
                    version = nAgt.substring(verOffset + 7);
                }
                    // Safari
                else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
                    browser = 'Safari';
                    version = nAgt.substring(verOffset + 7);
                    if ((verOffset = nAgt.indexOf('Version')) != -1) {
                        version = nAgt.substring(verOffset + 8);
                    }
                }
                    // Firefox
                else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
                    browser = 'Firefox';
                    version = nAgt.substring(verOffset + 8);
                }
                    // MSIE 11+
                else if (nAgt.indexOf('Trident/') != -1) {
                    browser = 'Microsoft Internet Explorer';
                    version = nAgt.substring(nAgt.indexOf('rv:') + 3);
                }
                    // Other browsers
                else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
                    browser = nAgt.substring(nameOffset, verOffset);
                    version = nAgt.substring(verOffset + 1);
                    if (browser.toLowerCase() == browser.toUpperCase()) {
                        browser = navigator.appName;
                    }
                }
                // trim the version string
                if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
                if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
                if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

                majorVersion = parseInt('' + version, 10);
                if (isNaN(majorVersion)) {
                    version = '' + parseFloat(navigator.appVersion);
                    majorVersion = parseInt(navigator.appVersion, 10);
                }

                // mobile version
                var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

                // cookie
                var cookieEnabled = (navigator.cookieEnabled) ? true : false;

                if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
                    document.cookie = 'testcookie';
                    cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
                }

                // system
                var os = unknown;
                var clientStrings = [
                    { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
                    { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
                    { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
                    { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
                    { s: 'Windows Vista', r: /Windows NT 6.0/ },
                    { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
                    { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
                    { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
                    { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
                    { s: 'Windows 98', r: /(Windows 98|Win98)/ },
                    { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
                    { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
                    { s: 'Windows CE', r: /Windows CE/ },
                    { s: 'Windows 3.11', r: /Win16/ },
                    { s: 'Android', r: /Android/ },
                    { s: 'Open BSD', r: /OpenBSD/ },
                    { s: 'Sun OS', r: /SunOS/ },
                    { s: 'Linux', r: /(Linux|X11)/ },
                    { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
                    { s: 'Mac OS X', r: /Mac OS X/ },
                    { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
                    { s: 'QNX', r: /QNX/ },
                    { s: 'UNIX', r: /UNIX/ },
                    { s: 'BeOS', r: /BeOS/ },
                    { s: 'OS/2', r: /OS\/2/ },
                    { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
                ];
                for (var id in clientStrings) {
                    var cs = clientStrings[id];
                    if (cs.r.test(nAgt)) {
                        os = cs.s;
                        break;
                    }
                }

                var osVersion = unknown;

                if (/Windows/.test(os)) {
                    osVersion = /Windows (.*)/.exec(os)[1];
                    os = 'Windows';
                }

                switch (os) {
                    case 'Mac OS X':
                        osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
                        break;

                    case 'Android':
                        osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
                        break;

                    case 'iOS':
                        osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                        osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
                        break;
                }

            }

            commit("set_platformdetails", {
                device: device,
                screen: screenSize,
                browser: browser,
                browserVersion: version,
                mobile: mobile,
                os: os,
                osVersion: osVersion,
                cookies: cookieEnabled,
            });
        }(this));

    },

    showNotification ({commit,state},data) {
		if(data != null) {
			if(typeof data.buttonLabel == "undefined") data["buttonLabel"] = "OK";
		}
        commit("set_notification",data);
    },

    loadSalonTeam({commit,state}) {
		if(state.lastSalonTeamSalonID == state.selectedSalonID) return;
        commit("set_loadingsalonteam",true);
        commit("set_salonteam",[]);
		state.lastSalonTeamSalonID = state.selectedSalonID;
		axios.post(localPrefix+'/shoponline/GetsalonTeam/', {
			SalonID: state.selectedSalonID,
			tenantInfo: JSON.stringify(getTenantInfoForRequest())
		}).then(function (response) {
			commit("set_salonteam",response.data.Data.Teammembers);
            commit("set_loadingsalonteam",false);
		}).catch(function (response) {
		})
	},

    chooseSalon({ commit,state,dispatch }, data) {
		commit("set_selectedSalonID", data.ID);
		//commit("set_selectedSalon", data);
		dispatch("setStripeInstance",data.spid);
		document.title = state.parameters.TenantName != data.Name ? (state.parameters.TenantName+"-"+data.Name) : state.parameters.TenantName;
	},

	checkGiftcardBalance({commit,state,dispatch}, data) {
        commit("set_checkinggiftcardbalance",true);
        commit("set_giftcardbalance",null);
		axios.post(localPrefix+'/shoponline/GiftcardBalance/', {
			reference: data.reference,
			tenantInfo: JSON.stringify(getTenantInfoForRequest())
		}).then(function (response) {
			commit("set_checkinggiftcardbalance",false);
			if(response.data.Status == "Success") {
				commit("set_giftcardbalance",response.data.Data);
                data.callback(response.data);
            } else {
                dispatch("showNotification",{message:"Failed to check giftcard. " + response.data.Message,style:{"background-color":"red",color:"white"},timeout:2000});
            }
		}).catch(function (response) {
		})
	},

	sendGiftcardByEmail ({commit,state,dispatch},data) {
		axios.post(localPrefix+'/shoponline/SendmyGC/', {
			reference: data.reference,
			EmailAddress: data.email,
			toname: data.to,
			fromname: data.from,
			message: data.message,
			tenantInfo: JSON.stringify(getTenantInfoForRequest())
		}).then(function (response) {
			if(response.data.Status == "Success") {
				dispatch("showNotification",{message:"Email sent successfully.",style:{'background-color':"lawngreen"},timeout:2000});
				callback(response.data);
			} else {
				dispatch("showNotification",{message:"Failed to send email. " + response.data.Message,style:{"background-color":"red",color:"white"},timeout:2000});
			}
		}).catch(function (response) {

		})
	},

	printGiftcard ({commit,state,dispatch},data) {
		axios.post(localPrefix+'/shoponline/PrintmyGC/', {
			reference: data.reference,
			toname: data.to,
			fromname: data.from,
			message: data.message,
			tenantInfo: JSON.stringify(getTenantInfoForRequest())
		}).then(function (response) {
			if(response.data.Status == "Success") {
				//callback(response.data);
				setTimeout(function(){
	                state.PHE.printHtml(response.data.Data.Print);
	            },0);
			} else {
				dispatch("showNotification",{message:"Print data failed to load. " + response.data.Message,style:{"background-color":"red",color:"white"},timeout:2000});
			}
		}).catch(function (response) {

		})
	},

	loadBookingAvailability ({commit,dispatch}, data) {
		commit("set_loadingbookingavailability",true);
        axios.post(localPrefix+'/shoponline/GetDateStatus',{
			source: "bp",
            items: data.items,
			startdate: data.startdate,
            tenantInfo: JSON.stringify(getTenantInfoForRequest())
        }).then( function (response) {
			commit("set_loadingbookingavailability",false);
			if(typeof response.data.Status == "undefined") {
            	//commit("set_bookingavailability",{ response:response.data });
				if(typeof data.callback == "function") data.callback(response.data);
			} else {
				dispatch("showNotification",{message:response.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
			}
        })
    },

	startAvailabilityCheck ({commit,dispatch}) {
		commit("set_checkingavailability",true);
	},

	recordWrongQuestions ({commit,dispatch}, data) {
		commit("set_loading",true);
		axios.post(localPrefix+'/shoponline/RecordWrongQuestionMarked', {
			items: data.items,
            questionsstring: data.qs,
			clientid: data.clientid,
			salonid: data.salonid
        }).then( function (response) {
			commit("set_loading",false);
			data.callback(response.data);
			// commit("set_loadingbookingavailability",false);
			// if(typeof response.data.Status == "undefined") {
            // 	//commit("set_bookingavailability",{ response:response.data });
			// 	if(typeof data.callback == "function") data.callback(response.data);
			// } else {
			// 	dispatch("showNotification",{message:response.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
			// }
        })
    },

	eraseBasket ({state}) {
		state.basket = [];
		localStorage.removeItem("BP_basket");
	},

	rehydrateBasket ({dispatch,state}) {

		function setItems(b) {
			var items2 = b.filter( (a) => {
				//filter out products and giftcards if these are disabled
				if(a.type == 3 && state.parameters.SellProductsOnline == false) return false;
				if(a.type == 2 && state.parameters.OnlineGCSaleType == 0) return false;
				return true;
			})
			state.basket = items2;
		}

		var basket = localStorage.getItem("BP_basket");
		if( basket != null ) {
			var b = JSON.parse(basket);
			if(typeof b.version != "undefined") {
				if(b.version == state.VERSION_BASKET) {
					if(b.salonid == state.urlParams.salonid) {
						setItems(b.items);
					} else {
						dispatch("eraseBasket");
						dispatch("showNotification",{message:"Basket contents from different salon were removed.",style:{'background-color':"red",color:"white"},timeout:2000});
					}
				} else {
					dispatch("eraseBasket");
					dispatch("showNotification",{message:"Basket version mismatch, basket contents removed.",style:{'background-color':"red",color:"white"},timeout:2000});
				}
			} else {
				dispatch("eraseBasket");
				dispatch("showNotification",{message:"Basket version missing, basket contents removed. Sorry for any inconvenience.",style:{'background-color':"red",color:"white"},timeout:2000});
			}

		}
	},

	loadServices ({commit,state,dispatch},callback) {
		commit("set_loadingservices", true);
        axios.post(localPrefix+"/shoponline/getServices",{ salonid: state.selectedSalonID, source: "bp" })
        .then(data => {
            if (data.data.Status == "Success") {
				data.data.Data.Services.sort(function(a,b){
					if (a.Sequence == 0 && b.Sequence > 0) return 1;
					if (a.Sequence > 0 && b.Sequence == 0) return -1;
					if (a.Sequence < b.Sequence) return -1;
					if (a.Sequence > b.Sequence) return 1;
					if(a.Service.toLowerCase() < b.Service.toLowerCase()) return -1;
					if(a.Service.toLowerCase() > b.Service.toLowerCase()) return 1;
					return 0;
				});				
				data.data.Data.Services.forEach( (item) => item["showDetailedDescription"]=false );
                commit("set_services",data.data.Data.Services);
				// var cats = [];
				// for(var i=0; i<data.data.Data.Services.length; i++) {
				// 	cats.pushIfNotExist({Description:data.data.Data.Services[i].SubCategory},function(a) { return a.Description == data.data.Data.Services[i].SubCategory; } );
				// }
				// cats.sort(function(a,b){
				// 	// if(a.Description>b.Description) return 1;
				// 	// if(a.Description<b.Description) return -1;
				// 	// return 0;
				// 	return a.SubCategorySequence - b.SubCategorySequence;
				// })
				commit("set_servicecategories",data.data.Data.Categories);
                commit("set_loadingservices", false);
            } else {
          	}
			callback(data.Data);
        });
    },

	loadTeammembers ({commit,state,dispatch},params) {
		commit("set_loadingteammembers", true);
        axios.post(localPrefix+"/shoponline/getTeammembers",{ serviceid: params.serviceid, mydate: params.date, salonid: state.selectedSalonID, selectedservices: params.selectedServices })
        .then(data => {
            if (data.data.Status == "Success") {
				if( !params.ispackage && (state.parameters.AllowMultipleTeamMembersforOnlineBooking || (!state.parameters.AllowMultipleTeamMembersforOnlineBooking && (data.data.Data.TeamMembers.length == 0 || params.selectedServices == "[]" ) ) ) ) {
					data.data.Data.TeamMembers.splice(0,0,{
						DayOff: false,
						Duration: 0,
						ExtraCharge: 0,
						ImageLink: state.parameters.OTCImageLink,
						Order: -5000000,
						Price: 0,
						PublicProfile: "",
						TeamMember: "Any team member",
						TeamMemberId: "00000000-0000-0000-0000-000000000000",
						selected: false
					});
				}
				if(data.data.Data.CategoryId != "") {
					dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
				}
                commit("set_teammembers",data.data.Data);
            } else {
				dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
				commit("set_teammembers",{
					TeamMembers: [],
					CategoryId: ""
				});
          	}
			params.callback(data.data);
			commit("set_loadingteammembers", false);
        });
    },

	loadServicesTF ({commit,state,dispatch},params) {
		commit("set_loadingservices", true);
        axios.post(localPrefix+"/shoponline/getServicesForTeammemberOnline",{ teammemberid: params.teammemberid, salonid: state.selectedSalonID, source: "bp" })
        .then(data => {
            if (data.data.Status == "Success") {
				data.data.Data.Services.sort(function(a,b){
					if (a.Sequence == 0 && b.Sequence > 0) return 1;
					if (a.Sequence > 0 && b.Sequence == 0) return -1;
					if (a.Sequence < b.Sequence) return -1;
					if (a.Sequence > b.Sequence) return 1;
					if(a.Service.toLowerCase() < b.Service.toLowerCase()) return -1;
					if(a.Service.toLowerCase() > b.Service.toLowerCase()) return 1;
					return 0;
				});
				data.data.Data.Services.forEach( (item) => item["showDetailedDescription"]=false );
                commit("set_services",data.data.Data.Services);
				commit("set_servicecategories",data.data.Data.Categories);
                commit("set_loadingservices", false);
            } else {
          	}
			params.callback(data.data);
        });
    },

	loadTeammembersTF ({commit,state,dispatch},params) {
		commit("set_loadingteammembers", true);
        axios.post(localPrefix+"/shoponline/getTeamMembersOnline",{ mydate: params.date, salonid: state.selectedSalonID, selectedservices: params.selectedServices })
        .then(data => {
            if (data.data.Status == "Success") {
				if(state.parameters.AllowMultipleTeamMembersforOnlineBooking || (!state.parameters.AllowMultipleTeamMembersforOnlineBooking && (data.data.Data.TeamMembers.length == 0 || params.selectedServices == "[]" ) ) ) {
					data.data.Data.TeamMembers.splice(0,0,{
						DayOff: false,
						Duration: 0,
						ExtraCharge: 0,
						ImageLink: state.parameters.OTCImageLink,
						Order: -5000000,
						Price: 0,
						PublicProfile: "",
						TeamMember: "Any team member",
						TeamMemberId: "00000000-0000-0000-0000-000000000000",
						selected: false
					});
				}
                commit("set_teammembers",data.data.Data);
            } else {
				dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:0});
				commit("set_teammembers",{
					TeamMembers: [],
					CategoryId: ""
				});
          	}
			params.callback(data.data);
			commit("set_loadingteammembers", false);
        });
    },

	loadTeammemberPrices ({commit,state,dispatch},params) {
        axios.post(localPrefix+"/shoponline/getServicesPriceforTeamMember",{ serviceids: params.serviceids, salonid: state.selectedSalonID, teammemberid: params.teammemberid })
        .then(data => {
            if (data.data.Status == "Success") {
            } else {
				dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:5000});
          	}
			params.callback(data.data);
        });
    },

	loadTeammembersRebook ({commit,state,dispatch},params) {
        axios.post(localPrefix+"/shoponline/getTeammembers",{ serviceid: params.serviceid, mydate: params.date, salonid: state.selectedSalonID })
        .then(data => {
            if (data.data.Status == "Success") {
            } else {
          	}
			params.callback(data.data);
        });
    },

	loadDateStatus ({commit,state,dispatch},params) {
		if(state.loadingdatestatus == true) {
			state.loadingDateStatusRequestCancel.cancel();
		}

		commit("set_loadingdatestatus", true);
		state.loadingDateStatusRequestCancel = AxiosCancelRequest.source();
		axios.post(localPrefix+"/shoponline/GetDateStatus",{
			source: params.source,
			availability: params.availability,
			items: params.items,
			startdate: params.date,
			salonid: params.salonid,
		},{cancelToken:state.loadingDateStatusRequestCancel.token}).then(data => {
            if (data.data.Status == "Success") {
				//console.log(data.data);
            } else {
				dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
          	}
			params.callback(data.data);
			commit("set_loadingdatestatus", false);
        }).catch(error => {});
	},

	loadNextAvailable ({commit,state,dispatch},params) {
		if(state.loadingdatestatus == true) {
			state.loadingDateStatusRequestCancel.cancel();
		}

		commit("set_loadingdatestatus", true);
		state.loadingDateStatusRequestCancel = AxiosCancelRequest.source();
		axios.post(localPrefix+"/shoponline/GetNextAvailableDate",{
			items: params.items,
			startdate: params.date,
			salonid: state.selectedSalonID
		},{cancelToken:state.loadingDateStatusRequestCancel.token}).then(data => {
			commit("set_loadingdatestatus", false);
            if (data.data.Status == "Success") {
				//console.log(data.data);
            } else {
				dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
          	}
			params.callback(data.data);
        }).catch(error => {});
	},

	loadQueueModeSlot ({commit,state,dispatch},params) {
		if(state.loadingdatestatus == true) {
			state.loadingDateStatusRequestCancel.cancel();
		}
		commit("set_loadingdatestatus", true);
		state.loadingDateStatusRequestCancel = AxiosCancelRequest.source();
		axios.post(localPrefix+"/shoponline/GetQueueModePrice",{			
			items: params.items,
			salonid: params.salonid,
		},{cancelToken:state.loadingDateStatusRequestCancel.token}).then(data => {
            if (data.data.Status == "Success") {
            } else {
				dispatch("showNotification",{message:data.data.Message,style:{'background-color':"red",color:"white"},timeout:2000});
          	}
			params.callback(data.data);
			commit("set_loadingdatestatus", false);
        }).catch(error => {});
	},

	sendQueueAnalytics ({commit,state,dispatch},params) {
		if(state.parameters.GA4ID!='') {
			gtag('event', 'purchase', {
				'transaction_id': params.UniqueIdentifier,
				'value':  params.TotalPrice,
				'currency': state.parameters.CurrencyDescription,
				'items': params.GA4Items,
				'purchase': params.Status,
				'purchase_type': params.ContentType,
				'salon': params.SalonName,
				'widget': 3,
				'shipping': "",
				'send_to': state.parameters.GA4ID
			});
		}
	},

	sendAnalytics ({commit,state,dispatch},params) {
		if(state.parameters.GA4ID!='') {
			gtag('event', 'purchase', {
				'transaction_id': params.UniqueIdentifier,
				'value':  params.TotalPrice,
				'currency': state.parameters.CurrencyDescription,
				'items': params.GA4Items,
				'purchase': params.Status,
				'purchase_type': params.ContentType,
				'salon': params.SalonName,
				'widget': 3,
				'shipping': params.Shipping,
				'send_to': state.parameters.GA4ID
			});
		} else {
			if(state.parameters.GATrackingID!='') {
				gtag('event', 'purchase', {
					'transaction_id': params.UniqueIdentifier,
					'value':  params.TotalPrice,
					'items': params.GAItems,
					'purchase': params.Status,
					'salon': params.SalonName,
					'purchase_type': params.ContentType,
					'widget': 3,
					'send_to': state.parameters.GATrackingID
				});
			}
		}
		// only send to SalonIQ
		// gtag('event', 'purchase', {
		// 	'transaction_id': params.UniqueIdentifier,
		// 	'value':  params.TotalPrice,
		// 	'items': params.GAItemsSalonIQ,
		// 	'purchase': params.Status,
		// 	'salon': params.SalonName,
		// 	'tenant': state.parameters.AccountCode,
		// 	'widget': 3,
		// 	'send_to': state.parameters.GATrackingIDSalonIQ
		// });
		gtag('event', 'purchase', {
			'transaction_id': params.UniqueIdentifier,
			'value':  params.TotalPrice,
			'currency': state.parameters.CurrencyDescription,
			'items': params.GA4ItemsSalonIQ,
			'purchase': params.Status,
			'salon': params.SalonName,
			'tenant': state.parameters.AccountCode,
			'purchase_type': params.ContentType,
			'widget': 3,
			'shipping': params.Shipping,
			'send_to': state.parameters.GA4IDSalonIQ
		});
		if(state.parameters.FBPixelID!="") {
			fbq('track', 'Purchase',
				{
				'transactionID': params.UniqueIdentifier,
				'value': params.TotalPrice,
				'currency': state.parameters.Currency,
				'contents': params.FBItems,
				'content_type': params.ContentType
				}
			);
		}
	}

}


export default {
    state,
    actions,
    mutations,
    getters
}
